import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toArray from "@babel/runtime/helpers/esm/toArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */
var Action;
(function (Action) {
  /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */
  Action["Pop"] = "POP";
  /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */
  Action["Push"] = "PUSH";
  /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */
  Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
var PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */
function createMemoryHistory(options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$initialEntri = _options.initialEntries,
    initialEntries = _options$initialEntri === void 0 ? ["/"] : _options$initialEntri,
    initialIndex = _options.initialIndex,
    _options$v5Compat = _options.v5Compat,
    v5Compat = _options$v5Compat === void 0 ? false : _options$v5Compat;
  var entries; // Declare so we can access from createMemoryLocation
  entries = initialEntries.map(function (entry, index) {
    return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
  });
  var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
  var action = Action.Pop;
  var listener = null;
  function clampIndex(n) {
    return Math.min(Math.max(n, 0), entries.length - 1);
  }
  function getCurrentLocation() {
    return entries[index];
  }
  function createMemoryLocation(to, state, key) {
    if (state === void 0) {
      state = null;
    }
    var location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
    warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
    return location;
  }
  function createHref(to) {
    return typeof to === "string" ? to : createPath(to);
  }
  var history = {
    get index() {
      return index;
    },
    get action() {
      return action;
    },
    get location() {
      return getCurrentLocation();
    },
    createHref: createHref,
    createURL: function createURL(to) {
      return new URL(createHref(to), "http://localhost");
    },
    encodeLocation: function encodeLocation(to) {
      var path = typeof to === "string" ? parsePath(to) : to;
      return {
        pathname: path.pathname || "",
        search: path.search || "",
        hash: path.hash || ""
      };
    },
    push: function push(to, state) {
      action = Action.Push;
      var nextLocation = createMemoryLocation(to, state);
      index += 1;
      entries.splice(index, entries.length, nextLocation);
      if (v5Compat && listener) {
        listener({
          action: action,
          location: nextLocation,
          delta: 1
        });
      }
    },
    replace: function replace(to, state) {
      action = Action.Replace;
      var nextLocation = createMemoryLocation(to, state);
      entries[index] = nextLocation;
      if (v5Compat && listener) {
        listener({
          action: action,
          location: nextLocation,
          delta: 0
        });
      }
    },
    go: function go(delta) {
      action = Action.Pop;
      var nextIndex = clampIndex(index + delta);
      var nextLocation = entries[nextIndex];
      index = nextIndex;
      if (listener) {
        listener({
          action: action,
          location: nextLocation,
          delta: delta
        });
      }
    },
    listen: function listen(fn) {
      listener = fn;
      return function () {
        listener = null;
      };
    }
  };
  return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */
function createBrowserHistory(options) {
  if (options === void 0) {
    options = {};
  }
  function createBrowserLocation(window, globalHistory) {
    var _window$location = window.location,
      pathname = _window$location.pathname,
      search = _window$location.search,
      hash = _window$location.hash;
    return createLocation("", {
      pathname: pathname,
      search: search,
      hash: hash
    },
    // state defaults to `null` because `window.history.state` does
    globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
  }
  function createBrowserHref(window, to) {
    return typeof to === "string" ? to : createPath(to);
  }
  return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */
function createHashHistory(options) {
  if (options === void 0) {
    options = {};
  }
  function createHashLocation(window, globalHistory) {
    var _parsePath = parsePath(window.location.hash.substr(1)),
      _parsePath$pathname = _parsePath.pathname,
      pathname = _parsePath$pathname === void 0 ? "/" : _parsePath$pathname,
      _parsePath$search = _parsePath.search,
      search = _parsePath$search === void 0 ? "" : _parsePath$search,
      _parsePath$hash = _parsePath.hash,
      hash = _parsePath$hash === void 0 ? "" : _parsePath$hash; // Hash URL should always have a leading / just like window.location.pathname
    // does, so if an app ends up at a route like /#something then we add a
    // leading slash so all of our path-matching behaves the same as if it would
    // in a browser router.  This is particularly important when there exists a
    // root splat route (<Route path="*">) since that matches internally against
    // "/*" and we'd expect /#something to 404 in a hash router app.
    if (!pathname.startsWith("/") && !pathname.startsWith(".")) {
      pathname = "/" + pathname;
    }
    return createLocation("", {
      pathname: pathname,
      search: search,
      hash: hash
    },
    // state defaults to `null` because `window.history.state` does
    globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
  }
  function createHashHref(window, to) {
    var base = window.document.querySelector("base");
    var href = "";
    if (base && base.getAttribute("href")) {
      var url = window.location.href;
      var hashIndex = url.indexOf("#");
      href = hashIndex === -1 ? url : url.slice(0, hashIndex);
    }
    return href + "#" + (typeof to === "string" ? to : createPath(to));
  }
  function validateHashLocation(location, to) {
    warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
  }
  return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
  if (value === false || value === null || typeof value === "undefined") {
    throw new Error(message);
  }
}
function warning(cond, message) {
  if (!cond) {
    // eslint-disable-next-line no-console
    if (typeof console !== "undefined") console.warn(message);
    try {
      // Welcome to debugging history!
      //
      // This error is thrown as a convenience, so you can more easily
      // find the source for a warning that appears in the console by
      // enabling "pause on exceptions" in your JavaScript debugger.
      throw new Error(message);
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }
}
function createKey() {
  return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */
function getHistoryState(location, index) {
  return {
    usr: location.state,
    key: location.key,
    idx: index
  };
}
/**
 * Creates a Location object with a unique key from the given Path
 */
function createLocation(current, to, state, key) {
  if (state === void 0) {
    state = null;
  }
  var location = _extends({
    pathname: typeof current === "string" ? current : current.pathname,
    search: "",
    hash: ""
  }, typeof to === "string" ? parsePath(to) : to, {
    state: state,
    // TODO: This could be cleaned up.  push/replace should probably just take
    // full Locations now and avoid the need to run through this flow at all
    // But that's a pretty big refactor to the current test suite so going to
    // keep as is for the time being and just let any incoming keys take precedence
    key: to && to.key || key || createKey()
  });
  return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */
function createPath(_ref) {
  var _ref$pathname = _ref.pathname,
    pathname = _ref$pathname === void 0 ? "/" : _ref$pathname,
    _ref$search = _ref.search,
    search = _ref$search === void 0 ? "" : _ref$search,
    _ref$hash = _ref.hash,
    hash = _ref$hash === void 0 ? "" : _ref$hash;
  if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
  if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
  return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */
function parsePath(path) {
  var parsedPath = {};
  if (path) {
    var hashIndex = path.indexOf("#");
    if (hashIndex >= 0) {
      parsedPath.hash = path.substr(hashIndex);
      path = path.substr(0, hashIndex);
    }
    var searchIndex = path.indexOf("?");
    if (searchIndex >= 0) {
      parsedPath.search = path.substr(searchIndex);
      path = path.substr(0, searchIndex);
    }
    if (path) {
      parsedPath.pathname = path;
    }
  }
  return parsedPath;
}
function getUrlBasedHistory(getLocation, _createHref, validateLocation, options) {
  if (options === void 0) {
    options = {};
  }
  var _options2 = options,
    _options2$window = _options2.window,
    window = _options2$window === void 0 ? document.defaultView : _options2$window,
    _options2$v5Compat = _options2.v5Compat,
    v5Compat = _options2$v5Compat === void 0 ? false : _options2$v5Compat;
  var globalHistory = window.history;
  var action = Action.Pop;
  var listener = null;
  var index = getIndex();
  // Index should only be null when we initialize. If not, it's because the
  // user called history.pushState or history.replaceState directly, in which
  // case we should log a warning as it will result in bugs.
  if (index == null) {
    index = 0;
    globalHistory.replaceState(_extends({}, globalHistory.state, {
      idx: index
    }), "");
  }
  function getIndex() {
    var state = globalHistory.state || {
      idx: null
    };
    return state.idx;
  }
  function handlePop() {
    action = Action.Pop;
    var nextIndex = getIndex();
    var delta = nextIndex == null ? null : nextIndex - index;
    index = nextIndex;
    if (listener) {
      listener({
        action: action,
        location: history.location,
        delta: delta
      });
    }
  }
  function push(to, state) {
    action = Action.Push;
    var location = createLocation(history.location, to, state);
    if (validateLocation) validateLocation(location, to);
    index = getIndex() + 1;
    var historyState = getHistoryState(location, index);
    var url = history.createHref(location);
    // try...catch because iOS limits us to 100 pushState calls :/
    try {
      globalHistory.pushState(historyState, "", url);
    } catch (error) {
      // If the exception is because `state` can't be serialized, let that throw
      // outwards just like a replace call would so the dev knows the cause
      // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
      // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
      if (error instanceof DOMException && error.name === "DataCloneError") {
        throw error;
      }
      // They are going to lose state here, but there is no real
      // way to warn them about it since the page will refresh...
      window.location.assign(url);
    }
    if (v5Compat && listener) {
      listener({
        action: action,
        location: history.location,
        delta: 1
      });
    }
  }
  function replace(to, state) {
    action = Action.Replace;
    var location = createLocation(history.location, to, state);
    if (validateLocation) validateLocation(location, to);
    index = getIndex();
    var historyState = getHistoryState(location, index);
    var url = history.createHref(location);
    globalHistory.replaceState(historyState, "", url);
    if (v5Compat && listener) {
      listener({
        action: action,
        location: history.location,
        delta: 0
      });
    }
  }
  function createURL(to) {
    // window.location.origin is "null" (the literal string value) in Firefox
    // under certain conditions, notably when serving from a local HTML file
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
    var base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    var href = typeof to === "string" ? to : createPath(to);
    // Treating this as a full URL will strip any trailing spaces so we need to
    // pre-encode them since they might be part of a matching splat param from
    // an ancestor route
    href = href.replace(/ $/, "%20");
    invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
    return new URL(href, base);
  }
  var history = {
    get action() {
      return action;
    },
    get location() {
      return getLocation(window, globalHistory);
    },
    listen: function listen(fn) {
      if (listener) {
        throw new Error("A history only accepts one active listener");
      }
      window.addEventListener(PopStateEventType, handlePop);
      listener = fn;
      return function () {
        window.removeEventListener(PopStateEventType, handlePop);
        listener = null;
      };
    },
    createHref: function createHref(to) {
      return _createHref(window, to);
    },
    createURL: createURL,
    encodeLocation: function encodeLocation(to) {
      // Encode a Location the same way window.location would
      var url = createURL(to);
      return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
      };
    },
    push: push,
    replace: replace,
    go: function go(n) {
      return globalHistory.go(n);
    }
  };
  return history;
}
//#endregion

var ResultType;
(function (ResultType) {
  ResultType["data"] = "data";
  ResultType["deferred"] = "deferred";
  ResultType["redirect"] = "redirect";
  ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
var immutableRouteKeys = new Set(["lazy", "caseSensitive", "path", "id", "index", "children"]);
function isIndexRoute(route) {
  return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
  if (parentPath === void 0) {
    parentPath = [];
  }
  if (manifest === void 0) {
    manifest = {};
  }
  return routes.map(function (route, index) {
    var treePath = [].concat(_toConsumableArray(parentPath), [String(index)]);
    var id = typeof route.id === "string" ? route.id : treePath.join("-");
    invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
    invariant(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
    if (isIndexRoute(route)) {
      var indexRoute = _extends({}, route, mapRouteProperties(route), {
        id: id
      });
      manifest[id] = indexRoute;
      return indexRoute;
    } else {
      var pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
        id: id,
        children: undefined
      });
      manifest[id] = pathOrLayoutRoute;
      if (route.children) {
        pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
      }
      return pathOrLayoutRoute;
    }
  });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */
function matchRoutes(routes, locationArg, basename) {
  if (basename === void 0) {
    basename = "/";
  }
  return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
  var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
  var pathname = stripBasename(location.pathname || "/", basename);
  if (pathname == null) {
    return null;
  }
  var branches = flattenRoutes(routes);
  rankRouteBranches(branches);
  var matches = null;
  for (var i = 0; matches == null && i < branches.length; ++i) {
    // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    var decoded = decodePath(pathname);
    matches = matchRouteBranch(branches[i], decoded, allowPartial);
  }
  return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
  var route = match.route,
    pathname = match.pathname,
    params = match.params;
  return {
    id: route.id,
    pathname: pathname,
    params: params,
    data: loaderData[route.id],
    handle: route.handle
  };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
  if (branches === void 0) {
    branches = [];
  }
  if (parentsMeta === void 0) {
    parentsMeta = [];
  }
  if (parentPath === void 0) {
    parentPath = "";
  }
  var flattenRoute = function flattenRoute(route, index, relativePath) {
    var meta = {
      relativePath: relativePath === undefined ? route.path || "" : relativePath,
      caseSensitive: route.caseSensitive === true,
      childrenIndex: index,
      route: route
    };
    if (meta.relativePath.startsWith("/")) {
      invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
      meta.relativePath = meta.relativePath.slice(parentPath.length);
    }
    var path = joinPaths([parentPath, meta.relativePath]);
    var routesMeta = parentsMeta.concat(meta);
    // Add the children before adding this route to the array, so we traverse the
    // route tree depth-first and child routes appear before their parents in
    // the "flattened" version.
    if (route.children && route.children.length > 0) {
      invariant(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
      flattenRoutes(route.children, branches, routesMeta, path);
    }
    // Routes without a path shouldn't ever match by themselves unless they are
    // index routes, so don't add them to the list of possible branches.
    if (route.path == null && !route.index) {
      return;
    }
    branches.push({
      path: path,
      score: computeScore(path, route.index),
      routesMeta: routesMeta
    });
  };
  routes.forEach(function (route, index) {
    var _route$path;
    // coarse-grain check for optional params
    if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) {
      flattenRoute(route, index);
    } else {
      var _iterator = _createForOfIteratorHelper(explodeOptionalSegments(route.path)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var exploded = _step.value;
          flattenRoute(route, index, exploded);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  });
  return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */
function explodeOptionalSegments(path) {
  var segments = path.split("/");
  if (segments.length === 0) return [];
  var _segments = _toArray(segments),
    first = _segments[0],
    rest = _segments.slice(1); // Optional path segments are denoted by a trailing `?`
  var isOptional = first.endsWith("?");
  // Compute the corresponding required segment: `foo?` -> `foo`
  var required = first.replace(/\?$/, "");
  if (rest.length === 0) {
    // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [required, ""] : [required];
  }
  var restExploded = explodeOptionalSegments(rest.join("/"));
  var result = [];
  // All child paths with the prefix.  Do this for all children before the
  // optional version for all children, so we get consistent ordering where the
  // parent optional aspect is preferred as required.  Otherwise, we can get
  // child sections interspersed where deeper optional segments are higher than
  // parent optional segments, where for example, /:two would explode _earlier_
  // then /:one.  By always including the parent as required _for all children_
  // first, we avoid this issue
  result.push.apply(result, _toConsumableArray(restExploded.map(function (subpath) {
    return subpath === "" ? required : [required, subpath].join("/");
  })));
  // Then, if this is an optional value, add all child versions without
  if (isOptional) {
    result.push.apply(result, _toConsumableArray(restExploded));
  }
  // for absolute paths, ensure `/` instead of empty segment
  return result.map(function (exploded) {
    return path.startsWith("/") && exploded === "" ? "/" : exploded;
  });
}
function rankRouteBranches(branches) {
  branches.sort(function (a, b) {
    return a.score !== b.score ? b.score - a.score // Higher score first
    : compareIndexes(a.routesMeta.map(function (meta) {
      return meta.childrenIndex;
    }), b.routesMeta.map(function (meta) {
      return meta.childrenIndex;
    }));
  });
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function isSplat(s) {
  return s === "*";
};
function computeScore(path, index) {
  var segments = path.split("/");
  var initialScore = segments.length;
  if (segments.some(isSplat)) {
    initialScore += splatPenalty;
  }
  if (index) {
    initialScore += indexRouteValue;
  }
  return segments.filter(function (s) {
    return !isSplat(s);
  }).reduce(function (score, segment) {
    return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
  }, initialScore);
}
function compareIndexes(a, b) {
  var siblings = a.length === b.length && a.slice(0, -1).every(function (n, i) {
    return n === b[i];
  });
  return siblings ?
  // If two routes are siblings, we should try to match the earlier sibling
  // first. This allows people to have fine-grained control over the matching
  // behavior by simply putting routes with identical paths in the order they
  // want them tried.
  a[a.length - 1] - b[b.length - 1] :
  // Otherwise, it doesn't really make sense to rank non-siblings by index,
  // so they sort equally.
  0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
  if (allowPartial === void 0) {
    allowPartial = false;
  }
  var routesMeta = branch.routesMeta;
  var matchedParams = {};
  var matchedPathname = "/";
  var matches = [];
  for (var i = 0; i < routesMeta.length; ++i) {
    var meta = routesMeta[i];
    var end = i === routesMeta.length - 1;
    var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
    var match = matchPath({
      path: meta.relativePath,
      caseSensitive: meta.caseSensitive,
      end: end
    }, remainingPathname);
    var route = meta.route;
    if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) {
      match = matchPath({
        path: meta.relativePath,
        caseSensitive: meta.caseSensitive,
        end: false
      }, remainingPathname);
    }
    if (!match) {
      return null;
    }
    Object.assign(matchedParams, match.params);
    matches.push({
      // TODO: Can this as be avoided?
      params: matchedParams,
      pathname: joinPaths([matchedPathname, match.pathname]),
      pathnameBase: normalizePathname(joinPaths([matchedPathname, match.pathnameBase])),
      route: route
    });
    if (match.pathnameBase !== "/") {
      matchedPathname = joinPaths([matchedPathname, match.pathnameBase]);
    }
  }
  return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */
function generatePath(originalPath, params) {
  if (params === void 0) {
    params = {};
  }
  var path = originalPath;
  if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
    warning(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    path = path.replace(/\*$/, "/*");
  }
  // ensure `/` is added at the beginning if the path is absolute
  var prefix = path.startsWith("/") ? "/" : "";
  var stringify = function stringify(p) {
    return p == null ? "" : typeof p === "string" ? p : String(p);
  };
  var segments = path.split(/\/+/).map(function (segment, index, array) {
    var isLastSegment = index === array.length - 1;
    // only apply the splat if it's the last segment
    if (isLastSegment && segment === "*") {
      var star = "*";
      // Apply the splat
      return stringify(params[star]);
    }
    var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
    if (keyMatch) {
      var _keyMatch = _slicedToArray(keyMatch, 3),
        key = _keyMatch[1],
        optional = _keyMatch[2];
      var param = params[key];
      invariant(optional === "?" || param != null, "Missing \":" + key + "\" param");
      return stringify(param);
    }
    // Remove any optional markers from optional static segments
    return segment.replace(/\?$/g, "");
  })
  // Remove empty segments
  .filter(function (segment) {
    return !!segment;
  });
  return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */
function matchPath(pattern, pathname) {
  if (typeof pattern === "string") {
    pattern = {
      path: pattern,
      caseSensitive: false,
      end: true
    };
  }
  var _compilePath = compilePath(pattern.path, pattern.caseSensitive, pattern.end),
    _compilePath2 = _slicedToArray(_compilePath, 2),
    matcher = _compilePath2[0],
    compiledParams = _compilePath2[1];
  var match = pathname.match(matcher);
  if (!match) return null;
  var matchedPathname = match[0];
  var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
  var captureGroups = match.slice(1);
  var params = compiledParams.reduce(function (memo, _ref, index) {
    var paramName = _ref.paramName,
      isOptional = _ref.isOptional; // We need to compute the pathnameBase here using the raw splat value
    // instead of using params["*"] later because it will be decoded then
    if (paramName === "*") {
      var splatValue = captureGroups[index] || "";
      pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
    }
    var value = captureGroups[index];
    if (isOptional && !value) {
      memo[paramName] = undefined;
    } else {
      memo[paramName] = (value || "").replace(/%2F/g, "/");
    }
    return memo;
  }, {});
  return {
    params: params,
    pathname: matchedPathname,
    pathnameBase: pathnameBase,
    pattern: pattern
  };
}
function compilePath(path, caseSensitive, end) {
  if (caseSensitive === void 0) {
    caseSensitive = false;
  }
  if (end === void 0) {
    end = true;
  }
  warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
  var params = [];
  var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
  .replace(/^\/*/, "/") // Make sure it has a leading /
  .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
  .replace(/\/:([\w-]+)(\?)?/g, function (_, paramName, isOptional) {
    params.push({
      paramName: paramName,
      isOptional: isOptional != null
    });
    return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
  });
  if (path.endsWith("*")) {
    params.push({
      paramName: "*"
    });
    regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
    : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
  } else if (end) {
    // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
  } else if (path !== "" && path !== "/") {
    // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
  } else ;
  var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
  return [matcher, params];
}
function decodePath(value) {
  try {
    return value.split("/").map(function (v) {
      return decodeURIComponent(v).replace(/\//g, "%2F");
    }).join("/");
  } catch (error) {
    warning(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
    return value;
  }
}
/**
 * @private
 */
function stripBasename(pathname, basename) {
  if (basename === "/") return pathname;
  if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) {
    return null;
  }
  // We want to leave trailing slash behavior in the user's control, so if they
  // specify a basename with a trailing slash, we should support it
  var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
  var nextChar = pathname.charAt(startIndex);
  if (nextChar && nextChar !== "/") {
    // pathname does not start with basename/
    return null;
  }
  return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */
function resolvePath(to, fromPathname) {
  if (fromPathname === void 0) {
    fromPathname = "/";
  }
  var _ref5 = typeof to === "string" ? parsePath(to) : to,
    toPathname = _ref5.pathname,
    _ref5$search = _ref5.search,
    search = _ref5$search === void 0 ? "" : _ref5$search,
    _ref5$hash = _ref5.hash,
    hash = _ref5$hash === void 0 ? "" : _ref5$hash;
  var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
  return {
    pathname: pathname,
    search: normalizeSearch(search),
    hash: normalizeHash(hash)
  };
}
function resolvePathname(relativePath, fromPathname) {
  var segments = fromPathname.replace(/\/+$/, "").split("/");
  var relativeSegments = relativePath.split("/");
  relativeSegments.forEach(function (segment) {
    if (segment === "..") {
      // Keep the root "" segment so the pathname starts at /
      if (segments.length > 1) segments.pop();
    } else if (segment !== ".") {
      segments.push(segment);
    }
  });
  return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
  return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */
function getPathContributingMatches(matches) {
  return matches.filter(function (match, index) {
    return index === 0 || match.route.path && match.route.path.length > 0;
  });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
  var pathMatches = getPathContributingMatches(matches);
  // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
  // match so we include splat values for "." links.  See:
  // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
  if (v7_relativeSplatPath) {
    return pathMatches.map(function (match, idx) {
      return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
  }
  return pathMatches.map(function (match) {
    return match.pathnameBase;
  });
}
/**
 * @private
 */
function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
  if (isPathRelative === void 0) {
    isPathRelative = false;
  }
  var to;
  if (typeof toArg === "string") {
    to = parsePath(toArg);
  } else {
    to = _extends({}, toArg);
    invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
    invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
    invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
  }
  var isEmptyPath = toArg === "" || to.pathname === "";
  var toPathname = isEmptyPath ? "/" : to.pathname;
  var from;
  // Routing is relative to the current pathname if explicitly requested.
  //
  // If a pathname is explicitly provided in `to`, it should be relative to the
  // route context. This is explained in `Note on `<Link to>` values` in our
  // migration guide from v5 as a means of disambiguation between `to` values
  // that begin with `/` and those that do not. However, this is problematic for
  // `to` values that do not provide a pathname. `to` can simply be a search or
  // hash string, in which case we should assume that the navigation is relative
  // to the current location's pathname and *not* the route pathname.
  if (toPathname == null) {
    from = locationPathname;
  } else {
    var routePathnameIndex = routePathnames.length - 1;
    // With relative="route" (the default), each leading .. segment means
    // "go up one route" instead of "go up one URL segment".  This is a key
    // difference from how <a href> works and a major reason we call this a
    // "to" value instead of a "href".
    if (!isPathRelative && toPathname.startsWith("..")) {
      var toSegments = toPathname.split("/");
      while (toSegments[0] === "..") {
        toSegments.shift();
        routePathnameIndex -= 1;
      }
      to.pathname = toSegments.join("/");
    }
    from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
  }
  var path = resolvePath(to, from);
  // Ensure the pathname has a trailing slash if the original "to" had one
  var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
  // Or if this was a link to the current path which has a trailing slash
  var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
  if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) {
    path.pathname += "/";
  }
  return path;
}
/**
 * @private
 */
function getToPathname(to) {
  // Empty strings should be treated the same as / paths
  return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */
var joinPaths = function joinPaths(paths) {
  return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */
var normalizePathname = function normalizePathname(pathname) {
  return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */
var normalizeSearch = function normalizeSearch(search) {
  return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */
var normalizeHash = function normalizeHash(hash) {
  return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */
var json = function json(data, init) {
  if (init === void 0) {
    init = {};
  }
  var responseInit = typeof init === "number" ? {
    status: init
  } : init;
  var headers = new Headers(responseInit.headers);
  if (!headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json; charset=utf-8");
  }
  return new Response(JSON.stringify(data), _extends({}, responseInit, {
    headers: headers
  }));
};
var DataWithResponseInit = function DataWithResponseInit(data, init) {
  _classCallCheck(this, DataWithResponseInit);
  this.type = "DataWithResponseInit";
  this.data = data;
  this.init = init || null;
};
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */
function data(data, init) {
  return new DataWithResponseInit(data, typeof init === "number" ? {
    status: init
  } : init);
}
var AbortedDeferredError = /*#__PURE__*/function (_Error) {
  _inherits(AbortedDeferredError, _Error);
  function AbortedDeferredError() {
    _classCallCheck(this, AbortedDeferredError);
    return _possibleConstructorReturn(this, _getPrototypeOf(AbortedDeferredError).apply(this, arguments));
  }
  return AbortedDeferredError;
}(_wrapNativeSuper(Error));
var DeferredData = /*#__PURE__*/function () {
  function DeferredData(data, responseInit) {
    var _this = this;
    _classCallCheck(this, DeferredData);
    this.pendingKeysSet = new Set();
    this.subscribers = new Set();
    this.deferredKeys = [];
    invariant(data && _typeof(data) === "object" && !Array.isArray(data), "defer() only accepts plain objects");
    // Set up an AbortController + Promise we can race against to exit early
    // cancellation
    var reject;
    this.abortPromise = new Promise(function (_, r) {
      return reject = r;
    });
    this.controller = new AbortController();
    var onAbort = function onAbort() {
      return reject(new AbortedDeferredError("Deferred data aborted"));
    };
    this.unlistenAbortSignal = function () {
      return _this.controller.signal.removeEventListener("abort", onAbort);
    };
    this.controller.signal.addEventListener("abort", onAbort);
    this.data = Object.entries(data).reduce(function (acc, _ref2) {
      var _ref6 = _slicedToArray(_ref2, 2),
        key = _ref6[0],
        value = _ref6[1];
      return Object.assign(acc, _defineProperty({}, key, _this.trackPromise(key, value)));
    }, {});
    if (this.done) {
      // All incoming values were resolved
      this.unlistenAbortSignal();
    }
    this.init = responseInit;
  }
  _createClass(DeferredData, [{
    key: "trackPromise",
    value: function trackPromise(key, value) {
      var _this2 = this;
      if (!(value instanceof Promise)) {
        return value;
      }
      this.deferredKeys.push(key);
      this.pendingKeysSet.add(key);
      // We store a little wrapper promise that will be extended with
      // _data/_error props upon resolve/reject
      var promise = Promise.race([value, this.abortPromise]).then(function (data) {
        return _this2.onSettle(promise, key, undefined, data);
      }, function (error) {
        return _this2.onSettle(promise, key, error);
      });
      // Register rejection listeners to avoid uncaught promise rejections on
      // errors or aborted deferred values
      promise.catch(function () {});
      Object.defineProperty(promise, "_tracked", {
        get: function get() {
          return true;
        }
      });
      return promise;
    }
  }, {
    key: "onSettle",
    value: function onSettle(promise, key, error, data) {
      if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
        this.unlistenAbortSignal();
        Object.defineProperty(promise, "_error", {
          get: function get() {
            return error;
          }
        });
        return Promise.reject(error);
      }
      this.pendingKeysSet.delete(key);
      if (this.done) {
        // Nothing left to abort!
        this.unlistenAbortSignal();
      }
      // If the promise was resolved/rejected with undefined, we'll throw an error as you
      // should always resolve with a value or null
      if (error === undefined && data === undefined) {
        var undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
        Object.defineProperty(promise, "_error", {
          get: function get() {
            return undefinedError;
          }
        });
        this.emit(false, key);
        return Promise.reject(undefinedError);
      }
      if (data === undefined) {
        Object.defineProperty(promise, "_error", {
          get: function get() {
            return error;
          }
        });
        this.emit(false, key);
        return Promise.reject(error);
      }
      Object.defineProperty(promise, "_data", {
        get: function get() {
          return data;
        }
      });
      this.emit(false, key);
      return data;
    }
  }, {
    key: "emit",
    value: function emit(aborted, settledKey) {
      this.subscribers.forEach(function (subscriber) {
        return subscriber(aborted, settledKey);
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(fn) {
      var _this3 = this;
      this.subscribers.add(fn);
      return function () {
        return _this3.subscribers.delete(fn);
      };
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var _this4 = this;
      this.controller.abort();
      this.pendingKeysSet.forEach(function (v, k) {
        return _this4.pendingKeysSet.delete(k);
      });
      this.emit(true);
    }
  }, {
    key: "resolveData",
    value: function () {
      var _resolveData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(signal) {
        var _this5 = this;
        var aborted, onAbort;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                aborted = false;
                if (this.done) {
                  _context.next = 7;
                  break;
                }
                onAbort = function onAbort() {
                  return _this5.cancel();
                };
                signal.addEventListener("abort", onAbort);
                _context.next = 6;
                return new Promise(function (resolve) {
                  _this5.subscribe(function (aborted) {
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || _this5.done) {
                      resolve(aborted);
                    }
                  });
                });
              case 6:
                aborted = _context.sent;
              case 7:
                return _context.abrupt("return", aborted);
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function resolveData(_x) {
        return _resolveData.apply(this, arguments);
      }
      return resolveData;
    }()
  }, {
    key: "done",
    get: function get() {
      return this.pendingKeysSet.size === 0;
    }
  }, {
    key: "unwrappedData",
    get: function get() {
      invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
      return Object.entries(this.data).reduce(function (acc, _ref3) {
        var _ref7 = _slicedToArray(_ref3, 2),
          key = _ref7[0],
          value = _ref7[1];
        return Object.assign(acc, _defineProperty({}, key, unwrapTrackedPromise(value)));
      }, {});
    }
  }, {
    key: "pendingKeys",
    get: function get() {
      return Array.from(this.pendingKeysSet);
    }
  }]);
  return DeferredData;
}();
function isTrackedPromise(value) {
  return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
  if (!isTrackedPromise(value)) {
    return value;
  }
  if (value._error) {
    throw value._error;
  }
  return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */
var defer = function defer(data, init) {
  if (init === void 0) {
    init = {};
  }
  var responseInit = typeof init === "number" ? {
    status: init
  } : init;
  return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */
var redirect = function redirect(url, init) {
  if (init === void 0) {
    init = 302;
  }
  var responseInit = init;
  if (typeof responseInit === "number") {
    responseInit = {
      status: responseInit
    };
  } else if (typeof responseInit.status === "undefined") {
    responseInit.status = 302;
  }
  var headers = new Headers(responseInit.headers);
  headers.set("Location", url);
  return new Response(null, _extends({}, responseInit, {
    headers: headers
  }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */
var redirectDocument = function redirectDocument(url, init) {
  var response = redirect(url, init);
  response.headers.set("X-Remix-Reload-Document", "true");
  return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */
var replace = function replace(url, init) {
  var response = redirect(url, init);
  response.headers.set("X-Remix-Replace", "true");
  return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */
var ErrorResponseImpl = function ErrorResponseImpl(status, statusText, data, internal) {
  _classCallCheck(this, ErrorResponseImpl);
  if (internal === void 0) {
    internal = false;
  }
  this.status = status;
  this.statusText = statusText || "";
  this.internal = internal;
  if (data instanceof Error) {
    this.data = data.toString();
    this.error = data;
  } else {
    this.data = data;
  }
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */
function isRouteErrorResponse(error) {
  return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var validMutationMethodsArr = ["post", "put", "patch", "delete"];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = ["get"].concat(validMutationMethodsArr);
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = new Set([301, 302, 303, 307, 308]);
var redirectPreserveMethodStatusCodes = new Set([307, 308]);
var IDLE_NAVIGATION = {
  state: "idle",
  location: undefined,
  formMethod: undefined,
  formAction: undefined,
  formEncType: undefined,
  formData: undefined,
  json: undefined,
  text: undefined
};
var IDLE_FETCHER = {
  state: "idle",
  data: undefined,
  formMethod: undefined,
  formAction: undefined,
  formEncType: undefined,
  formData: undefined,
  json: undefined,
  text: undefined
};
var IDLE_BLOCKER = {
  state: "unblocked",
  proceed: undefined,
  reset: undefined,
  location: undefined
};
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var defaultMapRouteProperties = function defaultMapRouteProperties(route) {
  return {
    hasErrorBoundary: Boolean(route.hasErrorBoundary)
  };
};
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */
function createRouter(init) {
  var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
  var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
  var isServer = !isBrowser;
  invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
  var mapRouteProperties;
  if (init.mapRouteProperties) {
    mapRouteProperties = init.mapRouteProperties;
  } else if (init.detectErrorBoundary) {
    // If they are still using the deprecated version, wrap it with the new API
    var detectErrorBoundary = init.detectErrorBoundary;
    mapRouteProperties = function mapRouteProperties(route) {
      return {
        hasErrorBoundary: detectErrorBoundary(route)
      };
    };
  } else {
    mapRouteProperties = defaultMapRouteProperties;
  }
  // Routes keyed by ID
  var manifest = {};
  // Routes in tree format for matching
  var dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
  var inFlightDataRoutes;
  var basename = init.basename || "/";
  var dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
  var patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
  // Config driven behavior flags
  var future = _extends({
    v7_fetcherPersist: false,
    v7_normalizeFormMethod: false,
    v7_partialHydration: false,
    v7_prependBasename: false,
    v7_relativeSplatPath: false,
    v7_skipActionErrorRevalidation: false
  }, init.future);
  // Cleanup function for history
  var unlistenHistory = null;
  // Externally-provided functions to call on all state changes
  var subscribers = new Set();
  // Externally-provided object to hold scroll restoration locations during routing
  var savedScrollPositions = null;
  // Externally-provided function to get scroll restoration keys
  var getScrollRestorationKey = null;
  // Externally-provided function to get current scroll position
  var getScrollPosition = null;
  // One-time flag to control the initial hydration scroll restoration.  Because
  // we don't get the saved positions from <ScrollRestoration /> until _after_
  // the initial render, we need to manually trigger a separate updateState to
  // send along the restoreScrollPosition
  // Set to true if we have `hydrationData` since we assume we were SSR'd and that
  // SSR did the initial scroll restoration.
  var initialScrollRestored = init.hydrationData != null;
  var initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
  var initialErrors = null;
  if (initialMatches == null && !patchRoutesOnNavigationImpl) {
    // If we do not match a user-provided-route, fall back to the root
    // to allow the error boundary to take over
    var error = getInternalRouterError(404, {
      pathname: init.history.location.pathname
    });
    var _getShortCircuitMatch = getShortCircuitMatches(dataRoutes),
      matches = _getShortCircuitMatch.matches,
      route = _getShortCircuitMatch.route;
    initialMatches = matches;
    initialErrors = _defineProperty({}, route.id, error);
  }
  // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
  // our initial match is a splat route, clear them out so we run through lazy
  // discovery on hydration in case there's a more accurate lazy route match.
  // In SSR apps (with `hydrationData`), we expect that the server will send
  // up the proper matched routes so we don't want to run lazy discovery on
  // initial hydration and want to hydrate into the splat route.
  if (initialMatches && !init.hydrationData) {
    var fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
    if (fogOfWar.active) {
      initialMatches = null;
    }
  }
  var initialized;
  if (!initialMatches) {
    initialized = false;
    initialMatches = [];
    // If partial hydration and fog of war is enabled, we will be running
    // `patchRoutesOnNavigation` during hydration so include any partial matches as
    // the initial matches so we can properly render `HydrateFallback`'s
    if (future.v7_partialHydration) {
      var _fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
      if (_fogOfWar.active && _fogOfWar.matches) {
        initialMatches = _fogOfWar.matches;
      }
    }
  } else if (initialMatches.some(function (m) {
    return m.route.lazy;
  })) {
    // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
  } else if (!initialMatches.some(function (m) {
    return m.route.loader;
  })) {
    // If we've got no loaders to run, then we're good to go
    initialized = true;
  } else if (future.v7_partialHydration) {
    // If partial hydration is enabled, we're initialized so long as we were
    // provided with hydrationData for every route with a loader, and no loaders
    // were marked for explicit hydration
    var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
    var errors = init.hydrationData ? init.hydrationData.errors : null;
    // If errors exist, don't consider routes below the boundary
    if (errors) {
      var idx = initialMatches.findIndex(function (m) {
        return errors[m.route.id] !== undefined;
      });
      initialized = initialMatches.slice(0, idx + 1).every(function (m) {
        return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
      });
    } else {
      initialized = initialMatches.every(function (m) {
        return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
      });
    }
  } else {
    // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
  }
  var router;
  var state = {
    historyAction: init.history.action,
    location: init.history.location,
    matches: initialMatches,
    initialized: initialized,
    navigation: IDLE_NAVIGATION,
    // Don't restore on initial updateState() if we were SSR'd
    restoreScrollPosition: init.hydrationData != null ? false : null,
    preventScrollReset: false,
    revalidation: "idle",
    loaderData: init.hydrationData && init.hydrationData.loaderData || {},
    actionData: init.hydrationData && init.hydrationData.actionData || null,
    errors: init.hydrationData && init.hydrationData.errors || initialErrors,
    fetchers: new Map(),
    blockers: new Map()
  };
  // -- Stateful internal variables to manage navigations --
  // Current navigation in progress (to be committed in completeNavigation)
  var pendingAction = Action.Pop;
  // Should the current navigation prevent the scroll reset if scroll cannot
  // be restored?
  var pendingPreventScrollReset = false;
  // AbortController for the active navigation
  var pendingNavigationController;
  // Should the current navigation enable document.startViewTransition?
  var pendingViewTransitionEnabled = false;
  // Store applied view transitions so we can apply them on POP
  var appliedViewTransitions = new Map();
  // Cleanup function for persisting applied transitions to sessionStorage
  var removePageHideEventListener = null;
  // We use this to avoid touching history in completeNavigation if a
  // revalidation is entirely uninterrupted
  var isUninterruptedRevalidation = false;
  // Use this internal flag to force revalidation of all loaders:
  //  - submissions (completed or interrupted)
  //  - useRevalidator()
  //  - X-Remix-Revalidate (from redirect)
  var isRevalidationRequired = false;
  // Use this internal array to capture routes that require revalidation due
  // to a cancelled deferred on action submission
  var cancelledDeferredRoutes = [];
  // Use this internal array to capture fetcher loads that were cancelled by an
  // action navigation and require revalidation
  var cancelledFetcherLoads = new Set();
  // AbortControllers for any in-flight fetchers
  var fetchControllers = new Map();
  // Track loads based on the order in which they started
  var incrementingLoadId = 0;
  // Track the outstanding pending navigation data load to be compared against
  // the globally incrementing load when a fetcher load lands after a completed
  // navigation
  var pendingNavigationLoadId = -1;
  // Fetchers that triggered data reloads as a result of their actions
  var fetchReloadIds = new Map();
  // Fetchers that triggered redirect navigations
  var fetchRedirectIds = new Set();
  // Most recent href/match for fetcher.load calls for fetchers
  var fetchLoadMatches = new Map();
  // Ref-count mounted fetchers so we know when it's ok to clean them up
  var activeFetchers = new Map();
  // Fetchers that have requested a delete when using v7_fetcherPersist,
  // they'll be officially removed after they return to idle
  var deletedFetchers = new Set();
  // Store DeferredData instances for active route matches.  When a
  // route loader returns defer() we stick one in here.  Then, when a nested
  // promise resolves we update loaderData.  If a new navigation starts we
  // cancel active deferreds for eliminated routes.
  var activeDeferreds = new Map();
  // Store blocker functions in a separate Map outside of router state since
  // we don't need to update UI state if they change
  var blockerFunctions = new Map();
  // Flag to ignore the next history update, so we can revert the URL change on
  // a POP navigation that was blocked by the user without touching router state
  var unblockBlockerHistoryUpdate = undefined;
  // Initialize the router, all side effects should be kicked off from here.
  // Implemented as a Fluent API for ease of:
  //   let router = createRouter(init).initialize();
  function initialize() {
    // If history informs us of a POP navigation, start the navigation but do not update
    // state.  We'll update our own state once the navigation completes
    unlistenHistory = init.history.listen(function (_ref) {
      var historyAction = _ref.action,
        location = _ref.location,
        delta = _ref.delta; // Ignore this event if it was just us resetting the URL from a
      // blocked POP navigation
      if (unblockBlockerHistoryUpdate) {
        unblockBlockerHistoryUpdate();
        unblockBlockerHistoryUpdate = undefined;
        return;
      }
      warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location " + "that was not created by @remix-run/router. This will fail silently in " + "production. This can happen if you are navigating outside the router " + "via `window.history.pushState`/`window.location.hash` instead of using " + "router navigation APIs.  This can also happen if you are using " + "createHashRouter and the user manually changes the URL.");
      var blockerKey = shouldBlockNavigation({
        currentLocation: state.location,
        nextLocation: location,
        historyAction: historyAction
      });
      if (blockerKey && delta != null) {
        // Restore the URL to match the current UI, but don't update router state
        var nextHistoryUpdatePromise = new Promise(function (resolve) {
          unblockBlockerHistoryUpdate = resolve;
        });
        init.history.go(delta * -1);
        // Put the blocker into a blocked state
        updateBlocker(blockerKey, {
          state: "blocked",
          location: location,
          proceed: function proceed() {
            updateBlocker(blockerKey, {
              state: "proceeding",
              proceed: undefined,
              reset: undefined,
              location: location
            });
            // Re-do the same POP navigation we just blocked, after the url
            // restoration is also complete.  See:
            // https://github.com/remix-run/react-router/issues/11613
            nextHistoryUpdatePromise.then(function () {
              return init.history.go(delta);
            });
          },
          reset: function reset() {
            var blockers = new Map(state.blockers);
            blockers.set(blockerKey, IDLE_BLOCKER);
            updateState({
              blockers: blockers
            });
          }
        });
        return;
      }
      return startNavigation(historyAction, location);
    });
    if (isBrowser) {
      // FIXME: This feels gross.  How can we cleanup the lines between
      // scrollRestoration/appliedTransitions persistance?
      restoreAppliedTransitions(routerWindow, appliedViewTransitions);
      var _saveAppliedTransitions = function _saveAppliedTransitions() {
        return persistAppliedTransitions(routerWindow, appliedViewTransitions);
      };
      routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
      removePageHideEventListener = function removePageHideEventListener() {
        return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
      };
    }
    // Kick off initial data load if needed.  Use Pop to avoid modifying history
    // Note we don't do any handling of lazy here.  For SPA's it'll get handled
    // in the normal navigation flow.  For SSR it's expected that lazy modules are
    // resolved prior to router creation since we can't go into a fallbackElement
    // UI for SSR'd apps
    if (!state.initialized) {
      startNavigation(Action.Pop, state.location, {
        initialHydration: true
      });
    }
    return router;
  }
  // Clean up a router and it's side effects
  function dispose() {
    if (unlistenHistory) {
      unlistenHistory();
    }
    if (removePageHideEventListener) {
      removePageHideEventListener();
    }
    subscribers.clear();
    pendingNavigationController && pendingNavigationController.abort();
    state.fetchers.forEach(function (_, key) {
      return deleteFetcher(key);
    });
    state.blockers.forEach(function (_, key) {
      return deleteBlocker(key);
    });
  }
  // Subscribe to state updates for the router
  function subscribe(fn) {
    subscribers.add(fn);
    return function () {
      return subscribers.delete(fn);
    };
  }
  // Update our state and notify the calling context of the change
  function updateState(newState, opts) {
    if (opts === void 0) {
      opts = {};
    }
    state = _extends({}, state, newState);
    // Prep fetcher cleanup so we can tell the UI which fetcher data entries
    // can be removed
    var completedFetchers = [];
    var deletedFetchersKeys = [];
    if (future.v7_fetcherPersist) {
      state.fetchers.forEach(function (fetcher, key) {
        if (fetcher.state === "idle") {
          if (deletedFetchers.has(key)) {
            // Unmounted from the UI and can be totally removed
            deletedFetchersKeys.push(key);
          } else {
            // Returned to idle but still mounted in the UI, so semi-remains for
            // revalidations and such
            completedFetchers.push(key);
          }
        }
      });
    }
    // Iterate over a local copy so that if flushSync is used and we end up
    // removing and adding a new subscriber due to the useCallback dependencies,
    // we don't get ourselves into a loop calling the new subscriber immediately
    _toConsumableArray(subscribers).forEach(function (subscriber) {
      return subscriber(state, {
        deletedFetchers: deletedFetchersKeys,
        viewTransitionOpts: opts.viewTransitionOpts,
        flushSync: opts.flushSync === true
      });
    });
    // Remove idle fetchers from state since we only care about in-flight fetchers.
    if (future.v7_fetcherPersist) {
      completedFetchers.forEach(function (key) {
        return state.fetchers.delete(key);
      });
      deletedFetchersKeys.forEach(function (key) {
        return deleteFetcher(key);
      });
    }
  }
  // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
  // and setting state.[historyAction/location/matches] to the new route.
  // - Location is a required param
  // - Navigation will always be set to IDLE_NAVIGATION
  // - Can pass any other state in newState
  function completeNavigation(location, newState, _temp) {
    var _location$state, _location$state2;
    var _ref8 = _temp === void 0 ? {} : _temp,
      flushSync = _ref8.flushSync; // Deduce if we're in a loading/actionReload state:
    // - We have committed actionData in the store
    // - The current navigation was a mutation submission
    // - We're past the submitting state and into the loading state
    // - The location being loaded is not the result of a redirect
    var isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
    var actionData;
    if (newState.actionData) {
      if (Object.keys(newState.actionData).length > 0) {
        actionData = newState.actionData;
      } else {
        // Empty actionData -> clear prior actionData due to an action error
        actionData = null;
      }
    } else if (isActionReload) {
      // Keep the current data if we're wrapping up the action reload
      actionData = state.actionData;
    } else {
      // Clear actionData on any other completed navigations
      actionData = null;
    }
    // Always preserve any existing loaderData from re-used routes
    var loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
    // On a successful navigation we can assume we got through all blockers
    // so we can start fresh
    var blockers = state.blockers;
    if (blockers.size > 0) {
      blockers = new Map(blockers);
      blockers.forEach(function (_, k) {
        return blockers.set(k, IDLE_BLOCKER);
      });
    }
    // Always respect the user flag.  Otherwise don't reset on mutation
    // submission navigations unless they redirect
    var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
    // Commit any in-flight routes at the end of the HMR revalidation "navigation"
    if (inFlightDataRoutes) {
      dataRoutes = inFlightDataRoutes;
      inFlightDataRoutes = undefined;
    }
    if (isUninterruptedRevalidation) ;else if (pendingAction === Action.Pop) ;else if (pendingAction === Action.Push) {
      init.history.push(location, location.state);
    } else if (pendingAction === Action.Replace) {
      init.history.replace(location, location.state);
    }
    var viewTransitionOpts;
    // On POP, enable transitions if they were enabled on the original navigation
    if (pendingAction === Action.Pop) {
      // Forward takes precedence so they behave like the original navigation
      var priorPaths = appliedViewTransitions.get(state.location.pathname);
      if (priorPaths && priorPaths.has(location.pathname)) {
        viewTransitionOpts = {
          currentLocation: state.location,
          nextLocation: location
        };
      } else if (appliedViewTransitions.has(location.pathname)) {
        // If we don't have a previous forward nav, assume we're popping back to
        // the new location and enable if that location previously enabled
        viewTransitionOpts = {
          currentLocation: location,
          nextLocation: state.location
        };
      }
    } else if (pendingViewTransitionEnabled) {
      // Store the applied transition on PUSH/REPLACE
      var toPaths = appliedViewTransitions.get(state.location.pathname);
      if (toPaths) {
        toPaths.add(location.pathname);
      } else {
        toPaths = new Set([location.pathname]);
        appliedViewTransitions.set(state.location.pathname, toPaths);
      }
      viewTransitionOpts = {
        currentLocation: state.location,
        nextLocation: location
      };
    }
    updateState(_extends({}, newState, {
      actionData: actionData,
      loaderData: loaderData,
      historyAction: pendingAction,
      location: location,
      initialized: true,
      navigation: IDLE_NAVIGATION,
      revalidation: "idle",
      restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
      preventScrollReset: preventScrollReset,
      blockers: blockers
    }), {
      viewTransitionOpts: viewTransitionOpts,
      flushSync: flushSync === true
    });
    // Reset stateful navigation vars
    pendingAction = Action.Pop;
    pendingPreventScrollReset = false;
    pendingViewTransitionEnabled = false;
    isUninterruptedRevalidation = false;
    isRevalidationRequired = false;
    cancelledDeferredRoutes = [];
  }
  // Trigger a navigation event, which can either be a numerical POP or a PUSH
  // replace with an optional submission
  function navigate(_x2, _x3) {
    return _navigate.apply(this, arguments);
  } // Revalidate all current loaders.  If a navigation is in progress or if this
  // is interrupted by a navigation, allow this to "succeed" by calling all
  // loaders during the next loader round
  function _navigate() {
    _navigate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(to, opts) {
      var normalizedPath, _normalizeNavigateOpt2, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(typeof to === "number")) {
                _context2.next = 3;
                break;
              }
              init.history.go(to);
              return _context2.abrupt("return");
            case 3:
              normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
              _normalizeNavigateOpt2 = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOpt2.path, submission = _normalizeNavigateOpt2.submission, error = _normalizeNavigateOpt2.error;
              currentLocation = state.location;
              nextLocation = createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
              // URL from window.location, so we need to encode it here so the behavior
              // remains the same as POP and non-data-router usages.  new URL() does all
              // the same encoding we'd get from a history.pushState/window.location read
              // without having to touch history
              nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
              userReplace = opts && opts.replace != null ? opts.replace : undefined;
              historyAction = Action.Push;
              if (userReplace === true) {
                historyAction = Action.Replace;
              } else if (userReplace === false) ;else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) {
                // By default on submissions to the current location we REPLACE so that
                // users don't have to double-click the back button to get to the prior
                // location.  If the user redirects to a different location from the
                // action/loader this will be ignored and the redirect will be a PUSH
                historyAction = Action.Replace;
              }
              preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
              flushSync = (opts && opts.flushSync) === true;
              blockerKey = shouldBlockNavigation({
                currentLocation: currentLocation,
                nextLocation: nextLocation,
                historyAction: historyAction
              });
              if (!blockerKey) {
                _context2.next = 17;
                break;
              }
              // Put the blocker into a blocked state
              updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed: function proceed() {
                  updateBlocker(blockerKey, {
                    state: "proceeding",
                    proceed: undefined,
                    reset: undefined,
                    location: nextLocation
                  });
                  // Send the same navigation through
                  navigate(to, opts);
                },
                reset: function reset() {
                  var blockers = new Map(state.blockers);
                  blockers.set(blockerKey, IDLE_BLOCKER);
                  updateState({
                    blockers: blockers
                  });
                }
              });
              return _context2.abrupt("return");
            case 17:
              _context2.next = 19;
              return startNavigation(historyAction, nextLocation, {
                submission: submission,
                // Send through the formData serialization error if we have one so we can
                // render at the right error boundary after we match routes
                pendingError: error,
                preventScrollReset: preventScrollReset,
                replace: opts && opts.replace,
                enableViewTransition: opts && opts.viewTransition,
                flushSync: flushSync
              });
            case 19:
              return _context2.abrupt("return", _context2.sent);
            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _navigate.apply(this, arguments);
  }
  function revalidate() {
    interruptActiveLoads();
    updateState({
      revalidation: "loading"
    });
    // If we're currently submitting an action, we don't need to start a new
    // navigation, we'll just let the follow up loader execution call all loaders
    if (state.navigation.state === "submitting") {
      return;
    }
    // If we're currently in an idle state, start a new navigation for the current
    // action/location and mark it as uninterrupted, which will skip the history
    // update in completeNavigation
    if (state.navigation.state === "idle") {
      startNavigation(state.historyAction, state.location, {
        startUninterruptedRevalidation: true
      });
      return;
    }
    // Otherwise, if we're currently in a loading state, just start a new
    // navigation to the navigation.location but do not trigger an uninterrupted
    // revalidation so that history correctly updates once the navigation completes
    startNavigation(pendingAction || state.historyAction, state.navigation.location, {
      overrideNavigation: state.navigation,
      // Proxy through any rending view transition
      enableViewTransition: pendingViewTransitionEnabled === true
    });
  }
  // Start a navigation to the given action/location.  Can optionally provide a
  // overrideNavigation which will override the normalLoad in the case of a redirect
  // navigation
  function startNavigation(_x4, _x5, _x6) {
    return _startNavigation.apply(this, arguments);
  } // Call the action matched by the leaf route for this navigation and handle
  // redirects/errors
  function _startNavigation() {
    _startNavigation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(historyAction, location, opts) {
      var routesToUse, loadingNavigation, matches, flushSync, fogOfWar, _handleNavigational, _error, notFoundMatches, _route, request, pendingActionResult, actionResult, _actionResult$pending, routeId, result, _yield$handleLoaders, shortCircuited, updatedMatches, loaderData, errors;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // Abort any in-progress navigations and start a new one. Unset any ongoing
              // uninterrupted revalidations unless told otherwise, since we want this
              // new navigation to update history normally
              pendingNavigationController && pendingNavigationController.abort();
              pendingNavigationController = null;
              pendingAction = historyAction;
              isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
              // Save the current scroll position every time we start a new navigation,
              // and track whether we should reset scroll on completion
              saveScrollPosition(state.location, state.matches);
              pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
              pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
              routesToUse = inFlightDataRoutes || dataRoutes;
              loadingNavigation = opts && opts.overrideNavigation;
              matches = matchRoutes(routesToUse, location, basename);
              flushSync = (opts && opts.flushSync) === true;
              fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
              if (fogOfWar.active && fogOfWar.matches) {
                matches = fogOfWar.matches;
              }
              // Short circuit with a 404 on the root error boundary if we match nothing
              if (matches) {
                _context3.next = 17;
                break;
              }
              _handleNavigational = handleNavigational404(location.pathname), _error = _handleNavigational.error, notFoundMatches = _handleNavigational.notFoundMatches, _route = _handleNavigational.route;
              completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: _defineProperty({}, _route.id, _error)
              }, {
                flushSync: flushSync
              });
              return _context3.abrupt("return");
            case 17:
              if (!(state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod)))) {
                _context3.next = 20;
                break;
              }
              completeNavigation(location, {
                matches: matches
              }, {
                flushSync: flushSync
              });
              return _context3.abrupt("return");
            case 20:
              // Create a controller/Request for this navigation
              pendingNavigationController = new AbortController();
              request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
              if (!(opts && opts.pendingError)) {
                _context3.next = 26;
                break;
              }
              // If we have a pendingError, it means the user attempted a GET submission
              // with binary FormData so assign here and skip to handleLoaders.  That
              // way we handle calling loaders above the boundary etc.  It's not really
              // different from an actionError in that sense.
              pendingActionResult = [findNearestBoundary(matches).route.id, {
                type: ResultType.error,
                error: opts.pendingError
              }];
              _context3.next = 44;
              break;
            case 26:
              if (!(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
                _context3.next = 44;
                break;
              }
              _context3.next = 29;
              return handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
              });
            case 29:
              actionResult = _context3.sent;
              if (!actionResult.shortCircuited) {
                _context3.next = 32;
                break;
              }
              return _context3.abrupt("return");
            case 32:
              if (!actionResult.pendingActionResult) {
                _context3.next = 38;
                break;
              }
              _actionResult$pending = _slicedToArray(actionResult.pendingActionResult, 2), routeId = _actionResult$pending[0], result = _actionResult$pending[1];
              if (!(isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404)) {
                _context3.next = 38;
                break;
              }
              pendingNavigationController = null;
              completeNavigation(location, {
                matches: actionResult.matches,
                loaderData: {},
                errors: _defineProperty({}, routeId, result.error)
              });
              return _context3.abrupt("return");
            case 38:
              matches = actionResult.matches || matches;
              pendingActionResult = actionResult.pendingActionResult;
              loadingNavigation = getLoadingNavigation(location, opts.submission);
              flushSync = false;
              // No need to do fog of war matching again on loader execution
              fogOfWar.active = false;
              // Create a GET request for the loaders
              request = createClientSideRequest(init.history, request.url, request.signal);
            case 44:
              _context3.next = 46;
              return handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
            case 46:
              _yield$handleLoaders = _context3.sent;
              shortCircuited = _yield$handleLoaders.shortCircuited;
              updatedMatches = _yield$handleLoaders.matches;
              loaderData = _yield$handleLoaders.loaderData;
              errors = _yield$handleLoaders.errors;
              if (!shortCircuited) {
                _context3.next = 53;
                break;
              }
              return _context3.abrupt("return");
            case 53:
              // Clean up now that the action/loaders have completed.  Don't clean up if
              // we short circuited because pendingNavigationController will have already
              // been assigned to a new controller for the next navigation
              pendingNavigationController = null;
              completeNavigation(location, _extends({
                matches: updatedMatches || matches
              }, getActionDataForCommit(pendingActionResult), {
                loaderData: loaderData,
                errors: errors
              }));
            case 55:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _startNavigation.apply(this, arguments);
  }
  function handleAction(_x7, _x8, _x9, _x10, _x11, _x12) {
    return _handleAction.apply(this, arguments);
  } // Call all applicable loaders for the given matches, handling redirects,
  // errors, etc.
  function _handleAction() {
    _handleAction = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(request, location, submission, matches, isFogOfWar, opts) {
      var navigation, discoverResult, boundaryId, _handleNavigational2, notFoundMatches, _error2, _route2, result, actionMatch, results, _replace, _location, boundaryMatch;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (opts === void 0) {
                opts = {};
              }
              interruptActiveLoads();
              // Put us in a submitting state
              navigation = getSubmittingNavigation(location, submission);
              updateState({
                navigation: navigation
              }, {
                flushSync: opts.flushSync === true
              });
              if (!isFogOfWar) {
                _context4.next = 23;
                break;
              }
              _context4.next = 7;
              return discoverRoutes(matches, location.pathname, request.signal);
            case 7:
              discoverResult = _context4.sent;
              if (!(discoverResult.type === "aborted")) {
                _context4.next = 12;
                break;
              }
              return _context4.abrupt("return", {
                shortCircuited: true
              });
            case 12:
              if (!(discoverResult.type === "error")) {
                _context4.next = 17;
                break;
              }
              boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
              return _context4.abrupt("return", {
                matches: discoverResult.partialMatches,
                pendingActionResult: [boundaryId, {
                  type: ResultType.error,
                  error: discoverResult.error
                }]
              });
            case 17:
              if (discoverResult.matches) {
                _context4.next = 22;
                break;
              }
              _handleNavigational2 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational2.notFoundMatches, _error2 = _handleNavigational2.error, _route2 = _handleNavigational2.route;
              return _context4.abrupt("return", {
                matches: notFoundMatches,
                pendingActionResult: [_route2.id, {
                  type: ResultType.error,
                  error: _error2
                }]
              });
            case 22:
              matches = discoverResult.matches;
            case 23:
              actionMatch = getTargetMatch(matches, location);
              if (!(!actionMatch.route.action && !actionMatch.route.lazy)) {
                _context4.next = 28;
                break;
              }
              result = {
                type: ResultType.error,
                error: getInternalRouterError(405, {
                  method: request.method,
                  pathname: location.pathname,
                  routeId: actionMatch.route.id
                })
              };
              _context4.next = 34;
              break;
            case 28:
              _context4.next = 30;
              return callDataStrategy("action", state, request, [actionMatch], matches, null);
            case 30:
              results = _context4.sent;
              result = results[actionMatch.route.id];
              if (!request.signal.aborted) {
                _context4.next = 34;
                break;
              }
              return _context4.abrupt("return", {
                shortCircuited: true
              });
            case 34:
              if (!isRedirectResult(result)) {
                _context4.next = 39;
                break;
              }
              if (opts && opts.replace != null) {
                _replace = opts.replace;
              } else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                _location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                _replace = _location === state.location.pathname + state.location.search;
              }
              _context4.next = 38;
              return startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: _replace
              });
            case 38:
              return _context4.abrupt("return", {
                shortCircuited: true
              });
            case 39:
              if (!isDeferredResult(result)) {
                _context4.next = 41;
                break;
              }
              throw getInternalRouterError(400, {
                type: "defer-action"
              });
            case 41:
              if (!isErrorResult(result)) {
                _context4.next = 45;
                break;
              }
              // Store off the pending error - we use it to determine which loaders
              // to call and will commit it when we complete the navigation
              boundaryMatch = findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions to the current location are REPLACE
              // navigations, but if the action threw an error that'll be rendered in
              // an errorElement, we fall back to PUSH so that the user can use the
              // back button to get back to the pre-submission form location to try
              // again
              if ((opts && opts.replace) !== true) {
                pendingAction = Action.Push;
              }
              return _context4.abrupt("return", {
                matches: matches,
                pendingActionResult: [boundaryMatch.route.id, result]
              });
            case 45:
              return _context4.abrupt("return", {
                matches: matches,
                pendingActionResult: [actionMatch.route.id, result]
              });
            case 46:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _handleAction.apply(this, arguments);
  }
  function handleLoaders(_x13, _x14, _x15, _x16, _x17, _x18, _x19, _x20, _x21, _x22, _x23) {
    return _handleLoaders.apply(this, arguments);
  }
  function _handleLoaders() {
    _handleLoaders = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
      var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, boundaryId, _handleNavigational3, _error3, notFoundMatches, _route3, routesToUse, _getMatchesToLoad, _getMatchesToLoad2, matchesToLoad, revalidatingFetchers, _updatedFetchers, updates, _actionData, abortPendingFetchRevalidations, _yield$callLoadersAnd, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, updatedFetchers, didAbortFetchLoads, shouldUpdateFetchers;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              // Figure out the right navigation we want to use for data loading
              loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission); // If this was a redirect from an action we don't have a "submission" but
              // we have it on the loading navigation so use that if available
              activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation); // If this is an uninterrupted revalidation, we remain in our current idle
              // state.  If not, we need to switch to our loading state and load data,
              // preserving any new action data or existing action data (in the case of
              // a revalidation interrupting an actionReload)
              // If we have partialHydration enabled, then don't update the state for the
              // initial data load since it's not a "navigation"
              shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration); // When fog of war is enabled, we enter our `loading` state earlier so we
              // can discover new routes during the `loading` state.  We skip this if
              // we've already run actions since we would have done our matching already.
              // If the children() function threw then, we want to proceed with the
              // partial matches it discovered.
              if (!isFogOfWar) {
                _context5.next = 23;
                break;
              }
              if (shouldUpdateNavigationState) {
                actionData = getUpdatedActionData(pendingActionResult);
                updateState(_extends({
                  navigation: loadingNavigation
                }, actionData !== undefined ? {
                  actionData: actionData
                } : {}), {
                  flushSync: flushSync
                });
              }
              _context5.next = 7;
              return discoverRoutes(matches, location.pathname, request.signal);
            case 7:
              discoverResult = _context5.sent;
              if (!(discoverResult.type === "aborted")) {
                _context5.next = 12;
                break;
              }
              return _context5.abrupt("return", {
                shortCircuited: true
              });
            case 12:
              if (!(discoverResult.type === "error")) {
                _context5.next = 17;
                break;
              }
              boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
              return _context5.abrupt("return", {
                matches: discoverResult.partialMatches,
                loaderData: {},
                errors: _defineProperty({}, boundaryId, discoverResult.error)
              });
            case 17:
              if (discoverResult.matches) {
                _context5.next = 22;
                break;
              }
              _handleNavigational3 = handleNavigational404(location.pathname), _error3 = _handleNavigational3.error, notFoundMatches = _handleNavigational3.notFoundMatches, _route3 = _handleNavigational3.route;
              return _context5.abrupt("return", {
                matches: notFoundMatches,
                loaderData: {},
                errors: _defineProperty({}, _route3.id, _error3)
              });
            case 22:
              matches = discoverResult.matches;
            case 23:
              routesToUse = inFlightDataRoutes || dataRoutes;
              _getMatchesToLoad = getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult), _getMatchesToLoad2 = _slicedToArray(_getMatchesToLoad, 2), matchesToLoad = _getMatchesToLoad2[0], revalidatingFetchers = _getMatchesToLoad2[1]; // Cancel pending deferreds for no-longer-matched routes or routes we're
              // about to reload.  Note that if this is an action reload we would have
              // already cancelled all pending deferreds so this would be a no-op
              cancelActiveDeferreds(function (routeId) {
                return !(matches && matches.some(function (m) {
                  return m.route.id === routeId;
                })) || matchesToLoad && matchesToLoad.some(function (m) {
                  return m.route.id === routeId;
                });
              });
              pendingNavigationLoadId = ++incrementingLoadId;
              // Short circuit if we have no loaders to run
              if (!(matchesToLoad.length === 0 && revalidatingFetchers.length === 0)) {
                _context5.next = 31;
                break;
              }
              _updatedFetchers = markFetchRedirectsDone();
              completeNavigation(location, _extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? _defineProperty({}, pendingActionResult[0], pendingActionResult[1].error) : null
              }, getActionDataForCommit(pendingActionResult), _updatedFetchers ? {
                fetchers: new Map(state.fetchers)
              } : {}), {
                flushSync: flushSync
              });
              return _context5.abrupt("return", {
                shortCircuited: true
              });
            case 31:
              if (shouldUpdateNavigationState) {
                updates = {};
                if (!isFogOfWar) {
                  // Only update navigation/actionNData if we didn't already do it above
                  updates.navigation = loadingNavigation;
                  _actionData = getUpdatedActionData(pendingActionResult);
                  if (_actionData !== undefined) {
                    updates.actionData = _actionData;
                  }
                }
                if (revalidatingFetchers.length > 0) {
                  updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                }
                updateState(updates, {
                  flushSync: flushSync
                });
              }
              revalidatingFetchers.forEach(function (rf) {
                abortFetcher(rf.key);
                if (rf.controller) {
                  // Fetchers use an independent AbortController so that aborting a fetcher
                  // (via deleteFetcher) does not abort the triggering navigation that
                  // triggered the revalidation
                  fetchControllers.set(rf.key, rf.controller);
                }
              });
              // Proxy navigation abort through to revalidation fetchers
              abortPendingFetchRevalidations = function abortPendingFetchRevalidations() {
                return revalidatingFetchers.forEach(function (f) {
                  return abortFetcher(f.key);
                });
              };
              if (pendingNavigationController) {
                pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
              }
              _context5.next = 37;
              return callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
            case 37:
              _yield$callLoadersAnd = _context5.sent;
              loaderResults = _yield$callLoadersAnd.loaderResults;
              fetcherResults = _yield$callLoadersAnd.fetcherResults;
              if (!request.signal.aborted) {
                _context5.next = 42;
                break;
              }
              return _context5.abrupt("return", {
                shortCircuited: true
              });
            case 42:
              // Clean up _after_ loaders have completed.  Don't clean up if we short
              // circuited because fetchControllers would have been aborted and
              // reassigned to new controllers for the next navigation
              if (pendingNavigationController) {
                pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
              }
              revalidatingFetchers.forEach(function (rf) {
                return fetchControllers.delete(rf.key);
              });
              // If any loaders returned a redirect Response, start a new REPLACE navigation
              redirect = findRedirect(loaderResults);
              if (!redirect) {
                _context5.next = 49;
                break;
              }
              _context5.next = 48;
              return startRedirectNavigation(request, redirect.result, true, {
                replace: replace
              });
            case 48:
              return _context5.abrupt("return", {
                shortCircuited: true
              });
            case 49:
              redirect = findRedirect(fetcherResults);
              if (!redirect) {
                _context5.next = 55;
                break;
              }
              // If this redirect came from a fetcher make sure we mark it in
              // fetchRedirectIds so it doesn't get revalidated on the next set of
              // loader executions
              fetchRedirectIds.add(redirect.key);
              _context5.next = 54;
              return startRedirectNavigation(request, redirect.result, true, {
                replace: replace
              });
            case 54:
              return _context5.abrupt("return", {
                shortCircuited: true
              });
            case 55:
              // Process and commit output from loaders
              _processLoaderData = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors; // Wire up subscribers to update loaderData as promises settle
              activeDeferreds.forEach(function (deferredData, routeId) {
                deferredData.subscribe(function (aborted) {
                  // Note: No need to updateState here since the TrackedPromise on
                  // loaderData is stable across resolve/reject
                  // Remove this instance if we were aborted or if promises have settled
                  if (aborted || deferredData.done) {
                    activeDeferreds.delete(routeId);
                  }
                });
              });
              // Preserve SSR errors during partial hydration
              if (future.v7_partialHydration && initialHydration && state.errors) {
                errors = _extends({}, state.errors, errors);
              }
              updatedFetchers = markFetchRedirectsDone();
              didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
              shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
              return _context5.abrupt("return", _extends({
                matches: matches,
                loaderData: loaderData,
                errors: errors
              }, shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
              } : {}));
            case 62:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _handleLoaders.apply(this, arguments);
  }
  function getUpdatedActionData(pendingActionResult) {
    if (pendingActionResult && !isErrorResult(pendingActionResult[1])) {
      // This is cast to `any` currently because `RouteData`uses any and it
      // would be a breaking change to use any.
      // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
      return _defineProperty({}, pendingActionResult[0], pendingActionResult[1].data);
    } else if (state.actionData) {
      if (Object.keys(state.actionData).length === 0) {
        return null;
      } else {
        return state.actionData;
      }
    }
  }
  function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
    revalidatingFetchers.forEach(function (rf) {
      var fetcher = state.fetchers.get(rf.key);
      var revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
      state.fetchers.set(rf.key, revalidatingFetcher);
    });
    return new Map(state.fetchers);
  }
  // Trigger a fetcher load/submit for the given fetcher key
  function fetch(key, routeId, href, opts) {
    if (isServer) {
      throw new Error("router.fetch() was called during the server render, but it shouldn't be. " + "You are likely calling a useFetcher() method in the body of your component. " + "Try moving it to a useEffect or a callback.");
    }
    abortFetcher(key);
    var flushSync = (opts && opts.flushSync) === true;
    var routesToUse = inFlightDataRoutes || dataRoutes;
    var normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
    var matches = matchRoutes(routesToUse, normalizedPath, basename);
    var fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
    if (fogOfWar.active && fogOfWar.matches) {
      matches = fogOfWar.matches;
    }
    if (!matches) {
      setFetcherError(key, routeId, getInternalRouterError(404, {
        pathname: normalizedPath
      }), {
        flushSync: flushSync
      });
      return;
    }
    var _normalizeNavigateOpt = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts),
      path = _normalizeNavigateOpt.path,
      submission = _normalizeNavigateOpt.submission,
      error = _normalizeNavigateOpt.error;
    if (error) {
      setFetcherError(key, routeId, error, {
        flushSync: flushSync
      });
      return;
    }
    var match = getTargetMatch(matches, path);
    var preventScrollReset = (opts && opts.preventScrollReset) === true;
    if (submission && isMutationMethod(submission.formMethod)) {
      handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
      return;
    }
    // Store off the match so we can call it's shouldRevalidate on subsequent
    // revalidations
    fetchLoadMatches.set(key, {
      routeId: routeId,
      path: path
    });
    handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
  }
  // Call the action for the matched fetcher.submit(), and then handle redirects,
  // errors, and revalidation
  function handleFetcherAction(_x24, _x25, _x26, _x27, _x28, _x29, _x30, _x31, _x32) {
    return _handleFetcherAction.apply(this, arguments);
  } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
  function _handleFetcherAction() {
    _handleFetcherAction = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
      var detectAndHandle405Error, existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, actionResults, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad3, _getMatchesToLoad4, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _yield$callLoadersAnd2, loaderResults, fetcherResults, redirect, _processLoaderData2, loaderData, errors, doneFetcher;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              detectAndHandle405Error = function _detectAndHandle405Er(m) {
                if (!m.route.action && !m.route.lazy) {
                  var _error4 = getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                  });
                  setFetcherError(key, routeId, _error4, {
                    flushSync: flushSync
                  });
                  return true;
                }
                return false;
              };
              interruptActiveLoads();
              fetchLoadMatches.delete(key);
              if (!(!isFogOfWar && detectAndHandle405Error(match))) {
                _context6.next = 5;
                break;
              }
              return _context6.abrupt("return");
            case 5:
              // Put this fetcher into it's submitting state
              existingFetcher = state.fetchers.get(key);
              updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
                flushSync: flushSync
              });
              abortController = new AbortController();
              fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
              if (!isFogOfWar) {
                _context6.next = 31;
                break;
              }
              _context6.next = 12;
              return discoverRoutes(requestMatches, path, fetchRequest.signal);
            case 12:
              discoverResult = _context6.sent;
              if (!(discoverResult.type === "aborted")) {
                _context6.next = 17;
                break;
              }
              return _context6.abrupt("return");
            case 17:
              if (!(discoverResult.type === "error")) {
                _context6.next = 22;
                break;
              }
              setFetcherError(key, routeId, discoverResult.error, {
                flushSync: flushSync
              });
              return _context6.abrupt("return");
            case 22:
              if (discoverResult.matches) {
                _context6.next = 27;
                break;
              }
              setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: path
              }), {
                flushSync: flushSync
              });
              return _context6.abrupt("return");
            case 27:
              requestMatches = discoverResult.matches;
              match = getTargetMatch(requestMatches, path);
              if (!detectAndHandle405Error(match)) {
                _context6.next = 31;
                break;
              }
              return _context6.abrupt("return");
            case 31:
              // Call the action for the fetcher
              fetchControllers.set(key, abortController);
              originatingLoadId = incrementingLoadId;
              _context6.next = 35;
              return callDataStrategy("action", state, fetchRequest, [match], requestMatches, key);
            case 35:
              actionResults = _context6.sent;
              actionResult = actionResults[match.route.id];
              if (!fetchRequest.signal.aborted) {
                _context6.next = 40;
                break;
              }
              // We can delete this so long as we weren't aborted by our own fetcher
              // re-submit which would have put _new_ controller is in fetchControllers
              if (fetchControllers.get(key) === abortController) {
                fetchControllers.delete(key);
              }
              return _context6.abrupt("return");
            case 40:
              if (!(future.v7_fetcherPersist && deletedFetchers.has(key))) {
                _context6.next = 46;
                break;
              }
              if (!(isRedirectResult(actionResult) || isErrorResult(actionResult))) {
                _context6.next = 44;
                break;
              }
              updateFetcherState(key, getDoneFetcher(undefined));
              return _context6.abrupt("return");
            case 44:
              _context6.next = 59;
              break;
            case 46:
              if (!isRedirectResult(actionResult)) {
                _context6.next = 56;
                break;
              }
              fetchControllers.delete(key);
              if (!(pendingNavigationLoadId > originatingLoadId)) {
                _context6.next = 53;
                break;
              }
              // A new navigation was kicked off after our action started, so that
              // should take precedence over this redirect navigation.  We already
              // set isRevalidationRequired so all loaders for the new route should
              // fire unless opted out via shouldRevalidate
              updateFetcherState(key, getDoneFetcher(undefined));
              return _context6.abrupt("return");
            case 53:
              fetchRedirectIds.add(key);
              updateFetcherState(key, getLoadingFetcher(submission));
              return _context6.abrupt("return", startRedirectNavigation(fetchRequest, actionResult, false, {
                fetcherSubmission: submission,
                preventScrollReset: preventScrollReset
              }));
            case 56:
              if (!isErrorResult(actionResult)) {
                _context6.next = 59;
                break;
              }
              setFetcherError(key, routeId, actionResult.error);
              return _context6.abrupt("return");
            case 59:
              if (!isDeferredResult(actionResult)) {
                _context6.next = 61;
                break;
              }
              throw getInternalRouterError(400, {
                type: "defer-action"
              });
            case 61:
              // Start the data load for current matches, or the next location if we're
              // in the middle of a navigation
              nextLocation = state.navigation.location || state.location;
              revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
              routesToUse = inFlightDataRoutes || dataRoutes;
              matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
              invariant(matches, "Didn't find any matches after fetcher action");
              loadId = ++incrementingLoadId;
              fetchReloadIds.set(key, loadId);
              loadFetcher = getLoadingFetcher(submission, actionResult.data);
              state.fetchers.set(key, loadFetcher);
              _getMatchesToLoad3 = getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [match.route.id, actionResult]), _getMatchesToLoad4 = _slicedToArray(_getMatchesToLoad3, 2), matchesToLoad = _getMatchesToLoad4[0], revalidatingFetchers = _getMatchesToLoad4[1]; // Put all revalidating fetchers into the loading state, except for the
              // current fetcher which we want to keep in it's current loading state which
              // contains it's action submission info + action data
              revalidatingFetchers.filter(function (rf) {
                return rf.key !== key;
              }).forEach(function (rf) {
                var staleKey = rf.key;
                var existingFetcher = state.fetchers.get(staleKey);
                var revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                state.fetchers.set(staleKey, revalidatingFetcher);
                abortFetcher(staleKey);
                if (rf.controller) {
                  fetchControllers.set(staleKey, rf.controller);
                }
              });
              updateState({
                fetchers: new Map(state.fetchers)
              });
              abortPendingFetchRevalidations = function abortPendingFetchRevalidations() {
                return revalidatingFetchers.forEach(function (rf) {
                  return abortFetcher(rf.key);
                });
              };
              abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
              _context6.next = 77;
              return callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
            case 77:
              _yield$callLoadersAnd2 = _context6.sent;
              loaderResults = _yield$callLoadersAnd2.loaderResults;
              fetcherResults = _yield$callLoadersAnd2.fetcherResults;
              if (!abortController.signal.aborted) {
                _context6.next = 82;
                break;
              }
              return _context6.abrupt("return");
            case 82:
              abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
              fetchReloadIds.delete(key);
              fetchControllers.delete(key);
              revalidatingFetchers.forEach(function (r) {
                return fetchControllers.delete(r.key);
              });
              redirect = findRedirect(loaderResults);
              if (!redirect) {
                _context6.next = 89;
                break;
              }
              return _context6.abrupt("return", startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
              }));
            case 89:
              redirect = findRedirect(fetcherResults);
              if (!redirect) {
                _context6.next = 93;
                break;
              }
              // If this redirect came from a fetcher make sure we mark it in
              // fetchRedirectIds so it doesn't get revalidated on the next set of
              // loader executions
              fetchRedirectIds.add(redirect.key);
              return _context6.abrupt("return", startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
              }));
            case 93:
              // Process and commit output from loaders
              _processLoaderData2 = processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData2.loaderData, errors = _processLoaderData2.errors; // Since we let revalidations complete even if the submitting fetcher was
              // deleted, only put it back to idle if it hasn't been deleted
              if (state.fetchers.has(key)) {
                doneFetcher = getDoneFetcher(actionResult.data);
                state.fetchers.set(key, doneFetcher);
              }
              abortStaleFetchLoads(loadId);
              // If we are currently in a navigation loading state and this fetcher is
              // more recent than the navigation, we want the newer data so abort the
              // navigation and complete it with the fetcher data
              if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                invariant(pendingAction, "Expected pending action");
                pendingNavigationController && pendingNavigationController.abort();
                completeNavigation(state.navigation.location, {
                  matches: matches,
                  loaderData: loaderData,
                  errors: errors,
                  fetchers: new Map(state.fetchers)
                });
              } else {
                // otherwise just update with the fetcher data, preserving any existing
                // loaderData for loaders that did not need to reload.  We have to
                // manually merge here since we aren't going through completeNavigation
                updateState({
                  errors: errors,
                  loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                  fetchers: new Map(state.fetchers)
                });
                isRevalidationRequired = false;
              }
            case 97:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return _handleFetcherAction.apply(this, arguments);
  }
  function handleFetcherLoader(_x33, _x34, _x35, _x36, _x37, _x38, _x39, _x40, _x41) {
    return _handleFetcherLoader.apply(this, arguments);
  }
  /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */
  function _handleFetcherLoader() {
    _handleFetcherLoader = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
      var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, results, result;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              existingFetcher = state.fetchers.get(key);
              updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                flushSync: flushSync
              });
              abortController = new AbortController();
              fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
              if (!isFogOfWar) {
                _context7.next = 24;
                break;
              }
              _context7.next = 7;
              return discoverRoutes(matches, path, fetchRequest.signal);
            case 7:
              discoverResult = _context7.sent;
              if (!(discoverResult.type === "aborted")) {
                _context7.next = 12;
                break;
              }
              return _context7.abrupt("return");
            case 12:
              if (!(discoverResult.type === "error")) {
                _context7.next = 17;
                break;
              }
              setFetcherError(key, routeId, discoverResult.error, {
                flushSync: flushSync
              });
              return _context7.abrupt("return");
            case 17:
              if (discoverResult.matches) {
                _context7.next = 22;
                break;
              }
              setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: path
              }), {
                flushSync: flushSync
              });
              return _context7.abrupt("return");
            case 22:
              matches = discoverResult.matches;
              match = getTargetMatch(matches, path);
            case 24:
              // Call the loader for this fetcher route match
              fetchControllers.set(key, abortController);
              originatingLoadId = incrementingLoadId;
              _context7.next = 28;
              return callDataStrategy("loader", state, fetchRequest, [match], matches, key);
            case 28:
              results = _context7.sent;
              result = results[match.route.id]; // Deferred isn't supported for fetcher loads, await everything and treat it
              // as a normal load.  resolveDeferredData will return undefined if this
              // fetcher gets aborted, so we just leave result untouched and short circuit
              // below if that happens
              if (!isDeferredResult(result)) {
                _context7.next = 37;
                break;
              }
              _context7.next = 33;
              return resolveDeferredData(result, fetchRequest.signal, true);
            case 33:
              _context7.t0 = _context7.sent;
              if (_context7.t0) {
                _context7.next = 36;
                break;
              }
              _context7.t0 = result;
            case 36:
              result = _context7.t0;
            case 37:
              // We can delete this so long as we weren't aborted by our our own fetcher
              // re-load which would have put _new_ controller is in fetchControllers
              if (fetchControllers.get(key) === abortController) {
                fetchControllers.delete(key);
              }
              if (!fetchRequest.signal.aborted) {
                _context7.next = 40;
                break;
              }
              return _context7.abrupt("return");
            case 40:
              if (!deletedFetchers.has(key)) {
                _context7.next = 43;
                break;
              }
              updateFetcherState(key, getDoneFetcher(undefined));
              return _context7.abrupt("return");
            case 43:
              if (!isRedirectResult(result)) {
                _context7.next = 53;
                break;
              }
              if (!(pendingNavigationLoadId > originatingLoadId)) {
                _context7.next = 49;
                break;
              }
              // A new navigation was kicked off after our loader started, so that
              // should take precedence over this redirect navigation
              updateFetcherState(key, getDoneFetcher(undefined));
              return _context7.abrupt("return");
            case 49:
              fetchRedirectIds.add(key);
              _context7.next = 52;
              return startRedirectNavigation(fetchRequest, result, false, {
                preventScrollReset: preventScrollReset
              });
            case 52:
              return _context7.abrupt("return");
            case 53:
              if (!isErrorResult(result)) {
                _context7.next = 56;
                break;
              }
              setFetcherError(key, routeId, result.error);
              return _context7.abrupt("return");
            case 56:
              invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
              // Put the fetcher back into an idle state
              updateFetcherState(key, getDoneFetcher(result.data));
            case 58:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    return _handleFetcherLoader.apply(this, arguments);
  }
  function startRedirectNavigation(_x42, _x43, _x44, _x45) {
    return _startRedirectNavigation.apply(this, arguments);
  } // Utility wrapper for calling dataStrategy client-side without having to
  // pass around the manifest, mapRouteProperties, etc.
  function _startRedirectNavigation() {
    _startRedirectNavigation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(request, redirect, isNavigation, _temp2) {
      var _ref11, submission, fetcherSubmission, preventScrollReset, replace, location, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state$navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _ref11 = _temp2 === void 0 ? {} : _temp2, submission = _ref11.submission, fetcherSubmission = _ref11.fetcherSubmission, preventScrollReset = _ref11.preventScrollReset, replace = _ref11.replace;
              if (redirect.response.headers.has("X-Remix-Revalidate")) {
                isRevalidationRequired = true;
              }
              location = redirect.response.headers.get("Location");
              invariant(location, "Expected a Location header on the redirect Response");
              location = normalizeRedirectLocation(location, new URL(request.url), basename);
              redirectLocation = createLocation(state.location, location, {
                _isRedirect: true
              });
              if (!isBrowser) {
                _context8.next = 12;
                break;
              }
              isDocumentReload = false;
              if (redirect.response.headers.has("X-Remix-Reload-Document")) {
                // Hard reload if the response contained X-Remix-Reload-Document
                isDocumentReload = true;
              } else if (ABSOLUTE_URL_REGEX.test(location)) {
                url = init.history.createURL(location);
                isDocumentReload =
                // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin ||
                // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
              }
              if (!isDocumentReload) {
                _context8.next = 12;
                break;
              }
              if (replace) {
                routerWindow.location.replace(location);
              } else {
                routerWindow.location.assign(location);
              }
              return _context8.abrupt("return");
            case 12:
              // There's no need to abort on redirects, since we don't detect the
              // redirect until the action/loaders have settled
              pendingNavigationController = null;
              redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push; // Use the incoming submission if provided, fallback on the active one in
              // state.navigation
              _state$navigation = state.navigation, formMethod = _state$navigation.formMethod, formAction = _state$navigation.formAction, formEncType = _state$navigation.formEncType;
              if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) {
                submission = getSubmissionFromNavigation(state.navigation);
              }
              // If this was a 307/308 submission we want to preserve the HTTP method and
              // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
              // redirected location
              activeSubmission = submission || fetcherSubmission;
              if (!(redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod))) {
                _context8.next = 22;
                break;
              }
              _context8.next = 20;
              return startNavigation(redirectHistoryAction, redirectLocation, {
                submission: _extends({}, activeSubmission, {
                  formAction: location
                }),
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
              });
            case 20:
              _context8.next = 25;
              break;
            case 22:
              // If we have a navigation submission, we will preserve it through the
              // redirect navigation
              overrideNavigation = getLoadingNavigation(redirectLocation, submission);
              _context8.next = 25;
              return startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission: fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
              });
            case 25:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
    return _startRedirectNavigation.apply(this, arguments);
  }
  function callDataStrategy(_x46, _x47, _x48, _x49, _x50, _x51) {
    return _callDataStrategy.apply(this, arguments);
  }
  function _callDataStrategy() {
    _callDataStrategy = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(type, state, request, matchesToLoad, matches, fetcherKey) {
      var results, dataResults, _i, _Object$entries, _Object$entries$_i, routeId, result, response;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              dataResults = {};
              _context9.prev = 1;
              _context9.next = 4;
              return callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
            case 4:
              results = _context9.sent;
              _context9.next = 11;
              break;
            case 7:
              _context9.prev = 7;
              _context9.t0 = _context9["catch"](1);
              // If the outer dataStrategy method throws, just return the error for all
              // matches - and it'll naturally bubble to the root
              matchesToLoad.forEach(function (m) {
                dataResults[m.route.id] = {
                  type: ResultType.error,
                  error: _context9.t0
                };
              });
              return _context9.abrupt("return", dataResults);
            case 11:
              _i = 0, _Object$entries = Object.entries(results);
            case 12:
              if (!(_i < _Object$entries.length)) {
                _context9.next = 25;
                break;
              }
              _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), routeId = _Object$entries$_i[0], result = _Object$entries$_i[1];
              if (!isRedirectDataStrategyResultResult(result)) {
                _context9.next = 19;
                break;
              }
              response = result.result;
              dataResults[routeId] = {
                type: ResultType.redirect,
                response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
              };
              _context9.next = 22;
              break;
            case 19:
              _context9.next = 21;
              return convertDataStrategyResultToDataResult(result);
            case 21:
              dataResults[routeId] = _context9.sent;
            case 22:
              _i++;
              _context9.next = 12;
              break;
            case 25:
              return _context9.abrupt("return", dataResults);
            case 26:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[1, 7]]);
    }));
    return _callDataStrategy.apply(this, arguments);
  }
  function callLoadersAndMaybeResolveData(_x52, _x53, _x54, _x55, _x56) {
    return _callLoadersAndMaybeResolveData.apply(this, arguments);
  }
  function _callLoadersAndMaybeResolveData() {
    _callLoadersAndMaybeResolveData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(state, matches, matchesToLoad, fetchersToLoad, request) {
      var currentMatches, loaderResultsPromise, fetcherResultsPromise, loaderResults, fetcherResults;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              currentMatches = state.matches; // Kick off loaders and fetchers in parallel
              loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
              fetcherResultsPromise = Promise.all(fetchersToLoad.map(/*#__PURE__*/function () {
                var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(f) {
                  var results, result;
                  return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          if (!(f.matches && f.match && f.controller)) {
                            _context10.next = 8;
                            break;
                          }
                          _context10.next = 3;
                          return callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [f.match], f.matches, f.key);
                        case 3:
                          results = _context10.sent;
                          result = results[f.match.route.id]; // Fetcher results are keyed by fetcher key from here on out, not routeId
                          return _context10.abrupt("return", _defineProperty({}, f.key, result));
                        case 8:
                          return _context10.abrupt("return", Promise.resolve(_defineProperty({}, f.key, {
                            type: ResultType.error,
                            error: getInternalRouterError(404, {
                              pathname: f.path
                            })
                          })));
                        case 9:
                        case "end":
                          return _context10.stop();
                      }
                    }
                  }, _callee10);
                }));
                return function (_x60) {
                  return _ref12.apply(this, arguments);
                };
              }()));
              _context11.next = 5;
              return loaderResultsPromise;
            case 5:
              loaderResults = _context11.sent;
              _context11.next = 8;
              return fetcherResultsPromise;
            case 8:
              _context11.t0 = function (acc, r) {
                return Object.assign(acc, r);
              };
              _context11.t1 = {};
              fetcherResults = _context11.sent.reduce(_context11.t0, _context11.t1);
              _context11.next = 13;
              return Promise.all([resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData), resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)]);
            case 13:
              return _context11.abrupt("return", {
                loaderResults: loaderResults,
                fetcherResults: fetcherResults
              });
            case 14:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));
    return _callLoadersAndMaybeResolveData.apply(this, arguments);
  }
  function interruptActiveLoads() {
    var _cancelledDeferredRou;
    // Every interruption triggers a revalidation
    isRevalidationRequired = true;
    // Cancel pending route-level deferreds and mark cancelled routes for
    // revalidation
    (_cancelledDeferredRou = cancelledDeferredRoutes).push.apply(_cancelledDeferredRou, _toConsumableArray(cancelActiveDeferreds()));
    // Abort in-flight fetcher loads
    fetchLoadMatches.forEach(function (_, key) {
      if (fetchControllers.has(key)) {
        cancelledFetcherLoads.add(key);
      }
      abortFetcher(key);
    });
  }
  function updateFetcherState(key, fetcher, opts) {
    if (opts === void 0) {
      opts = {};
    }
    state.fetchers.set(key, fetcher);
    updateState({
      fetchers: new Map(state.fetchers)
    }, {
      flushSync: (opts && opts.flushSync) === true
    });
  }
  function setFetcherError(key, routeId, error, opts) {
    if (opts === void 0) {
      opts = {};
    }
    var boundaryMatch = findNearestBoundary(state.matches, routeId);
    deleteFetcher(key);
    updateState({
      errors: _defineProperty({}, boundaryMatch.route.id, error),
      fetchers: new Map(state.fetchers)
    }, {
      flushSync: (opts && opts.flushSync) === true
    });
  }
  function getFetcher(key) {
    if (future.v7_fetcherPersist) {
      activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
      // If this fetcher was previously marked for deletion, unmark it since we
      // have a new instance
      if (deletedFetchers.has(key)) {
        deletedFetchers.delete(key);
      }
    }
    return state.fetchers.get(key) || IDLE_FETCHER;
  }
  function deleteFetcher(key) {
    var fetcher = state.fetchers.get(key);
    // Don't abort the controller if this is a deletion of a fetcher.submit()
    // in it's loading phase since - we don't want to abort the corresponding
    // revalidation and want them to complete and land
    if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) {
      abortFetcher(key);
    }
    fetchLoadMatches.delete(key);
    fetchReloadIds.delete(key);
    fetchRedirectIds.delete(key);
    deletedFetchers.delete(key);
    cancelledFetcherLoads.delete(key);
    state.fetchers.delete(key);
  }
  function deleteFetcherAndUpdateState(key) {
    if (future.v7_fetcherPersist) {
      var count = (activeFetchers.get(key) || 0) - 1;
      if (count <= 0) {
        activeFetchers.delete(key);
        deletedFetchers.add(key);
      } else {
        activeFetchers.set(key, count);
      }
    } else {
      deleteFetcher(key);
    }
    updateState({
      fetchers: new Map(state.fetchers)
    });
  }
  function abortFetcher(key) {
    var controller = fetchControllers.get(key);
    if (controller) {
      controller.abort();
      fetchControllers.delete(key);
    }
  }
  function markFetchersDone(keys) {
    var _iterator2 = _createForOfIteratorHelper(keys),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var key = _step2.value;
        var fetcher = getFetcher(key);
        var doneFetcher = getDoneFetcher(fetcher.data);
        state.fetchers.set(key, doneFetcher);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  function markFetchRedirectsDone() {
    var doneKeys = [];
    var updatedFetchers = false;
    var _iterator3 = _createForOfIteratorHelper(fetchRedirectIds),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var key = _step3.value;
        var fetcher = state.fetchers.get(key);
        invariant(fetcher, "Expected fetcher: " + key);
        if (fetcher.state === "loading") {
          fetchRedirectIds.delete(key);
          doneKeys.push(key);
          updatedFetchers = true;
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    markFetchersDone(doneKeys);
    return updatedFetchers;
  }
  function abortStaleFetchLoads(landedId) {
    var yeetedKeys = [];
    var _iterator4 = _createForOfIteratorHelper(fetchReloadIds),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _step4$value = _slicedToArray(_step4.value, 2),
          key = _step4$value[0],
          id = _step4$value[1];
        if (id < landedId) {
          var fetcher = state.fetchers.get(key);
          invariant(fetcher, "Expected fetcher: " + key);
          if (fetcher.state === "loading") {
            abortFetcher(key);
            fetchReloadIds.delete(key);
            yeetedKeys.push(key);
          }
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    markFetchersDone(yeetedKeys);
    return yeetedKeys.length > 0;
  }
  function getBlocker(key, fn) {
    var blocker = state.blockers.get(key) || IDLE_BLOCKER;
    if (blockerFunctions.get(key) !== fn) {
      blockerFunctions.set(key, fn);
    }
    return blocker;
  }
  function deleteBlocker(key) {
    state.blockers.delete(key);
    blockerFunctions.delete(key);
  }
  // Utility function to update blockers, ensuring valid state transitions
  function updateBlocker(key, newBlocker) {
    var blocker = state.blockers.get(key) || IDLE_BLOCKER;
    // Poor mans state machine :)
    // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
    invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
    var blockers = new Map(state.blockers);
    blockers.set(key, newBlocker);
    updateState({
      blockers: blockers
    });
  }
  function shouldBlockNavigation(_ref2) {
    var currentLocation = _ref2.currentLocation,
      nextLocation = _ref2.nextLocation,
      historyAction = _ref2.historyAction;
    if (blockerFunctions.size === 0) {
      return;
    }
    // We ony support a single active blocker at the moment since we don't have
    // any compelling use cases for multi-blocker yet
    if (blockerFunctions.size > 1) {
      warning(false, "A router only supports one blocker at a time");
    }
    var entries = Array.from(blockerFunctions.entries());
    var _entries = _slicedToArray(entries[entries.length - 1], 2),
      blockerKey = _entries[0],
      blockerFunction = _entries[1];
    var blocker = state.blockers.get(blockerKey);
    if (blocker && blocker.state === "proceeding") {
      // If the blocker is currently proceeding, we don't need to re-check
      // it and can let this navigation continue
      return;
    }
    // At this point, we know we're unblocked/blocked so we need to check the
    // user-provided blocker function
    if (blockerFunction({
      currentLocation: currentLocation,
      nextLocation: nextLocation,
      historyAction: historyAction
    })) {
      return blockerKey;
    }
  }
  function handleNavigational404(pathname) {
    var error = getInternalRouterError(404, {
      pathname: pathname
    });
    var routesToUse = inFlightDataRoutes || dataRoutes;
    var _getShortCircuitMatch2 = getShortCircuitMatches(routesToUse),
      matches = _getShortCircuitMatch2.matches,
      route = _getShortCircuitMatch2.route; // Cancel all pending deferred on 404s since we don't keep any routes
    cancelActiveDeferreds();
    return {
      notFoundMatches: matches,
      route: route,
      error: error
    };
  }
  function cancelActiveDeferreds(predicate) {
    var cancelledRouteIds = [];
    activeDeferreds.forEach(function (dfd, routeId) {
      if (!predicate || predicate(routeId)) {
        // Cancel the deferred - but do not remove from activeDeferreds here -
        // we rely on the subscribers to do that so our tests can assert proper
        // cleanup via _internalActiveDeferreds
        dfd.cancel();
        cancelledRouteIds.push(routeId);
        activeDeferreds.delete(routeId);
      }
    });
    return cancelledRouteIds;
  }
  // Opt in to capturing and reporting scroll positions during navigations,
  // used by the <ScrollRestoration> component
  function enableScrollRestoration(positions, getPosition, getKey) {
    savedScrollPositions = positions;
    getScrollPosition = getPosition;
    getScrollRestorationKey = getKey || null;
    // Perform initial hydration scroll restoration, since we miss the boat on
    // the initial updateState() because we've not yet rendered <ScrollRestoration/>
    // and therefore have no savedScrollPositions available
    if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
      initialScrollRestored = true;
      var y = getSavedScrollPosition(state.location, state.matches);
      if (y != null) {
        updateState({
          restoreScrollPosition: y
        });
      }
    }
    return function () {
      savedScrollPositions = null;
      getScrollPosition = null;
      getScrollRestorationKey = null;
    };
  }
  function getScrollKey(location, matches) {
    if (getScrollRestorationKey) {
      var key = getScrollRestorationKey(location, matches.map(function (m) {
        return convertRouteMatchToUiMatch(m, state.loaderData);
      }));
      return key || location.key;
    }
    return location.key;
  }
  function saveScrollPosition(location, matches) {
    if (savedScrollPositions && getScrollPosition) {
      var key = getScrollKey(location, matches);
      savedScrollPositions[key] = getScrollPosition();
    }
  }
  function getSavedScrollPosition(location, matches) {
    if (savedScrollPositions) {
      var key = getScrollKey(location, matches);
      var y = savedScrollPositions[key];
      if (typeof y === "number") {
        return y;
      }
    }
    return null;
  }
  function checkFogOfWar(matches, routesToUse, pathname) {
    if (patchRoutesOnNavigationImpl) {
      if (!matches) {
        var fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
        return {
          active: true,
          matches: fogMatches || []
        };
      } else {
        if (Object.keys(matches[0].params).length > 0) {
          // If we matched a dynamic param or a splat, it might only be because
          // we haven't yet discovered other routes that would match with a
          // higher score.  Call patchRoutesOnNavigation just to be sure
          var partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
          return {
            active: true,
            matches: partialMatches
          };
        }
      }
    }
    return {
      active: false,
      matches: null
    };
  }
  function discoverRoutes(_x57, _x58, _x59) {
    return _discoverRoutes.apply(this, arguments);
  }
  function _discoverRoutes() {
    _discoverRoutes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(matches, pathname, signal) {
      var partialMatches, _loop, _ret;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              if (patchRoutesOnNavigationImpl) {
                _context13.next = 2;
                break;
              }
              return _context13.abrupt("return", {
                type: "success",
                matches: matches
              });
            case 2:
              partialMatches = matches;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
                var isNonHMR, routesToUse, localManifest, newMatches, newPartialMatches;
                return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        isNonHMR = inFlightDataRoutes == null;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        localManifest = manifest;
                        _context12.prev = 3;
                        _context12.next = 6;
                        return patchRoutesOnNavigationImpl({
                          path: pathname,
                          matches: partialMatches,
                          patch: function patch(routeId, children) {
                            if (signal.aborted) return;
                            patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                          }
                        });
                      case 6:
                        _context12.next = 11;
                        break;
                      case 8:
                        _context12.prev = 8;
                        _context12.t0 = _context12["catch"](3);
                        return _context12.abrupt("return", {
                          v: {
                            type: "error",
                            error: _context12.t0,
                            partialMatches: partialMatches
                          }
                        });
                      case 11:
                        _context12.prev = 11;
                        // If we are not in the middle of an HMR revalidation and we changed the
                        // routes, provide a new identity so when we `updateState` at the end of
                        // this navigation/fetch `router.routes` will be a new identity and
                        // trigger a re-run of memoized `router.routes` dependencies.
                        // HMR will already update the identity and reflow when it lands
                        // `inFlightDataRoutes` in `completeNavigation`
                        if (isNonHMR && !signal.aborted) {
                          dataRoutes = _toConsumableArray(dataRoutes);
                        }
                        return _context12.finish(11);
                      case 14:
                        if (!signal.aborted) {
                          _context12.next = 16;
                          break;
                        }
                        return _context12.abrupt("return", {
                          v: {
                            type: "aborted"
                          }
                        });
                      case 16:
                        newMatches = matchRoutes(routesToUse, pathname, basename);
                        if (!newMatches) {
                          _context12.next = 19;
                          break;
                        }
                        return _context12.abrupt("return", {
                          v: {
                            type: "success",
                            matches: newMatches
                          }
                        });
                      case 19:
                        newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true); // Avoid loops if the second pass results in the same partial matches
                        if (!(!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every(function (m, i) {
                          return m.route.id === newPartialMatches[i].route.id;
                        }))) {
                          _context12.next = 22;
                          break;
                        }
                        return _context12.abrupt("return", {
                          v: {
                            type: "success",
                            matches: null
                          }
                        });
                      case 22:
                        partialMatches = newPartialMatches;
                      case 23:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, _callee12, null, [[3, 8, 11, 14]]);
              });
            case 4:
              if (!true) {
                _context13.next = 11;
                break;
              }
              return _context13.delegateYield(_loop(), "t0", 6);
            case 6:
              _ret = _context13.t0;
              if (!(_typeof(_ret) === "object")) {
                _context13.next = 9;
                break;
              }
              return _context13.abrupt("return", _ret.v);
            case 9:
              _context13.next = 4;
              break;
            case 11:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));
    return _discoverRoutes.apply(this, arguments);
  }
  function _internalSetRoutes(newRoutes) {
    manifest = {};
    inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
  }
  function patchRoutes(routeId, children) {
    var isNonHMR = inFlightDataRoutes == null;
    var routesToUse = inFlightDataRoutes || dataRoutes;
    patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
    // If we are not in the middle of an HMR revalidation and we changed the
    // routes, provide a new identity and trigger a reflow via `updateState`
    // to re-run memoized `router.routes` dependencies.
    // HMR will already update the identity and reflow when it lands
    // `inFlightDataRoutes` in `completeNavigation`
    if (isNonHMR) {
      dataRoutes = _toConsumableArray(dataRoutes);
      updateState({});
    }
  }
  router = {
    get basename() {
      return basename;
    },
    get future() {
      return future;
    },
    get state() {
      return state;
    },
    get routes() {
      return dataRoutes;
    },
    get window() {
      return routerWindow;
    },
    initialize: initialize,
    subscribe: subscribe,
    enableScrollRestoration: enableScrollRestoration,
    navigate: navigate,
    fetch: fetch,
    revalidate: revalidate,
    // Passthrough to history-aware createHref used by useHref so we get proper
    // hash-aware URLs in DOM paths
    createHref: function createHref(to) {
      return init.history.createHref(to);
    },
    encodeLocation: function encodeLocation(to) {
      return init.history.encodeLocation(to);
    },
    getFetcher: getFetcher,
    deleteFetcher: deleteFetcherAndUpdateState,
    dispose: dispose,
    getBlocker: getBlocker,
    deleteBlocker: deleteBlocker,
    patchRoutes: patchRoutes,
    _internalFetchControllers: fetchControllers,
    _internalActiveDeferreds: activeDeferreds,
    // TODO: Remove setRoutes, it's temporary to avoid dealing with
    // updating the tree while validating the update algorithm.
    _internalSetRoutes: _internalSetRoutes
  };
  return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
  invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
  var manifest = {};
  var basename = (opts ? opts.basename : null) || "/";
  var mapRouteProperties;
  if (opts != null && opts.mapRouteProperties) {
    mapRouteProperties = opts.mapRouteProperties;
  } else if (opts != null && opts.detectErrorBoundary) {
    // If they are still using the deprecated version, wrap it with the new API
    var detectErrorBoundary = opts.detectErrorBoundary;
    mapRouteProperties = function mapRouteProperties(route) {
      return {
        hasErrorBoundary: detectErrorBoundary(route)
      };
    };
  } else {
    mapRouteProperties = defaultMapRouteProperties;
  }
  // Config driven behavior flags
  var future = _extends({
    v7_relativeSplatPath: false,
    v7_throwAbortReason: false
  }, opts ? opts.future : null);
  var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
  /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */
  function query(_x61, _x62) {
    return _query.apply(this, arguments);
  }
  /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */
  function _query() {
    _query = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(request, _temp3) {
      var _ref14, requestContext, skipLoaderErrorBubbling, dataStrategy, url, method, location, matches, error, _getShortCircuitMatch3, methodNotAllowedMatches, route, _error5, _getShortCircuitMatch4, notFoundMatches, _route4, result;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _ref14 = _temp3 === void 0 ? {} : _temp3, requestContext = _ref14.requestContext, skipLoaderErrorBubbling = _ref14.skipLoaderErrorBubbling, dataStrategy = _ref14.dataStrategy;
              url = new URL(request.url);
              method = request.method;
              location = createLocation("", createPath(url), null, "default");
              matches = matchRoutes(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
              if (!(!isValidMethod(method) && method !== "HEAD")) {
                _context14.next = 11;
                break;
              }
              error = getInternalRouterError(405, {
                method: method
              });
              _getShortCircuitMatch3 = getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatch3.matches, route = _getShortCircuitMatch3.route;
              return _context14.abrupt("return", {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: _defineProperty({}, route.id, error),
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
              });
            case 11:
              if (matches) {
                _context14.next = 15;
                break;
              }
              _error5 = getInternalRouterError(404, {
                pathname: location.pathname
              });
              _getShortCircuitMatch4 = getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatch4.matches, _route4 = _getShortCircuitMatch4.route;
              return _context14.abrupt("return", {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: _defineProperty({}, _route4.id, _error5),
                statusCode: _error5.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
              });
            case 15:
              _context14.next = 17;
              return queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
            case 17:
              result = _context14.sent;
              if (!isResponse(result)) {
                _context14.next = 20;
                break;
              }
              return _context14.abrupt("return", result);
            case 20:
              return _context14.abrupt("return", _extends({
                location: location,
                basename: basename
              }, result));
            case 21:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));
    return _query.apply(this, arguments);
  }
  function queryRoute(_x63, _x64) {
    return _queryRoute.apply(this, arguments);
  }
  function _queryRoute() {
    _queryRoute = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(request, _temp4) {
      var _ref15, routeId, requestContext, dataStrategy, url, method, location, matches, match, result, error, _result$activeDeferre, _data;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _ref15 = _temp4 === void 0 ? {} : _temp4, routeId = _ref15.routeId, requestContext = _ref15.requestContext, dataStrategy = _ref15.dataStrategy;
              url = new URL(request.url);
              method = request.method;
              location = createLocation("", createPath(url), null, "default");
              matches = matchRoutes(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
              if (!(!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS")) {
                _context15.next = 9;
                break;
              }
              throw getInternalRouterError(405, {
                method: method
              });
            case 9:
              if (matches) {
                _context15.next = 11;
                break;
              }
              throw getInternalRouterError(404, {
                pathname: location.pathname
              });
            case 11:
              match = routeId ? matches.find(function (m) {
                return m.route.id === routeId;
              }) : getTargetMatch(matches, location);
              if (!(routeId && !match)) {
                _context15.next = 16;
                break;
              }
              throw getInternalRouterError(403, {
                pathname: location.pathname,
                routeId: routeId
              });
            case 16:
              if (match) {
                _context15.next = 18;
                break;
              }
              throw getInternalRouterError(404, {
                pathname: location.pathname
              });
            case 18:
              _context15.next = 20;
              return queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
            case 20:
              result = _context15.sent;
              if (!isResponse(result)) {
                _context15.next = 23;
                break;
              }
              return _context15.abrupt("return", result);
            case 23:
              error = result.errors ? Object.values(result.errors)[0] : undefined;
              if (!(error !== undefined)) {
                _context15.next = 26;
                break;
              }
              throw error;
            case 26:
              if (!result.actionData) {
                _context15.next = 28;
                break;
              }
              return _context15.abrupt("return", Object.values(result.actionData)[0]);
            case 28:
              if (!result.loaderData) {
                _context15.next = 32;
                break;
              }
              _data = Object.values(result.loaderData)[0];
              if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) {
                _data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
              }
              return _context15.abrupt("return", _data);
            case 32:
              return _context15.abrupt("return", undefined);
            case 33:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));
    return _queryRoute.apply(this, arguments);
  }
  function queryImpl(_x65, _x66, _x67, _x68, _x69, _x70, _x71) {
    return _queryImpl.apply(this, arguments);
  }
  function _queryImpl() {
    _queryImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
      var _result, result;
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
              _context16.prev = 1;
              if (!isMutationMethod(request.method.toLowerCase())) {
                _context16.next = 7;
                break;
              }
              _context16.next = 5;
              return submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
            case 5:
              _result = _context16.sent;
              return _context16.abrupt("return", _result);
            case 7:
              _context16.next = 9;
              return loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            case 9:
              result = _context16.sent;
              return _context16.abrupt("return", isResponse(result) ? result : _extends({}, result, {
                actionData: null,
                actionHeaders: {}
              }));
            case 13:
              _context16.prev = 13;
              _context16.t0 = _context16["catch"](1);
              if (!(isDataStrategyResult(_context16.t0) && isResponse(_context16.t0.result))) {
                _context16.next = 19;
                break;
              }
              if (!(_context16.t0.type === ResultType.error)) {
                _context16.next = 18;
                break;
              }
              throw _context16.t0.result;
            case 18:
              return _context16.abrupt("return", _context16.t0.result);
            case 19:
              if (!isRedirectResponse(_context16.t0)) {
                _context16.next = 21;
                break;
              }
              return _context16.abrupt("return", _context16.t0);
            case 21:
              throw _context16.t0;
            case 22:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, null, [[1, 13]]);
    }));
    return _queryImpl.apply(this, arguments);
  }
  function submit(_x72, _x73, _x74, _x75, _x76, _x77, _x78) {
    return _submit.apply(this, arguments);
  }
  function _submit() {
    _submit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
      var result, error, results, _error6, loaderRequest, boundaryMatch, _context17, context;
      return _regeneratorRuntime.wrap(function _callee17$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              if (!(!actionMatch.route.action && !actionMatch.route.lazy)) {
                _context18.next = 7;
                break;
              }
              error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
              });
              if (!isRouteRequest) {
                _context18.next = 4;
                break;
              }
              throw error;
            case 4:
              result = {
                type: ResultType.error,
                error: error
              };
              _context18.next = 12;
              break;
            case 7:
              _context18.next = 9;
              return callDataStrategy("action", request, [actionMatch], matches, isRouteRequest, requestContext, dataStrategy);
            case 9:
              results = _context18.sent;
              result = results[actionMatch.route.id];
              if (request.signal.aborted) {
                throwStaticHandlerAbortedError(request, isRouteRequest, future);
              }
            case 12:
              if (!isRedirectResult(result)) {
                _context18.next = 14;
                break;
              }
              throw new Response(null, {
                status: result.response.status,
                headers: {
                  Location: result.response.headers.get("Location")
                }
              });
            case 14:
              if (!isDeferredResult(result)) {
                _context18.next = 19;
                break;
              }
              _error6 = getInternalRouterError(400, {
                type: "defer-action"
              });
              if (!isRouteRequest) {
                _context18.next = 18;
                break;
              }
              throw _error6;
            case 18:
              result = {
                type: ResultType.error,
                error: _error6
              };
            case 19:
              if (!isRouteRequest) {
                _context18.next = 23;
                break;
              }
              if (!isErrorResult(result)) {
                _context18.next = 22;
                break;
              }
              throw result.error;
            case 22:
              return _context18.abrupt("return", {
                matches: [actionMatch],
                loaderData: {},
                actionData: _defineProperty({}, actionMatch.route.id, result.data),
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
              });
            case 23:
              // Create a GET request for the loaders
              loaderRequest = new Request(request.url, {
                headers: request.headers,
                redirect: request.redirect,
                signal: request.signal
              });
              if (!isErrorResult(result)) {
                _context18.next = 30;
                break;
              }
              // Store off the pending error - we use it to determine which loaders
              // to call and will commit it when we complete the navigation
              boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
              _context18.next = 28;
              return loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [boundaryMatch.route.id, result]);
            case 28:
              _context17 = _context18.sent;
              return _context18.abrupt("return", _extends({}, _context17, {
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: _extends({}, result.headers ? _defineProperty({}, actionMatch.route.id, result.headers) : {})
              }));
            case 30:
              _context18.next = 32;
              return loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
            case 32:
              context = _context18.sent;
              return _context18.abrupt("return", _extends({}, context, {
                actionData: _defineProperty({}, actionMatch.route.id, result.data)
              }, result.statusCode ? {
                statusCode: result.statusCode
              } : {}, {
                actionHeaders: result.headers ? _defineProperty({}, actionMatch.route.id, result.headers) : {}
              }));
            case 34:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee17);
    }));
    return _submit.apply(this, arguments);
  }
  function loadRouteData(_x79, _x80, _x81, _x82, _x83, _x84, _x85) {
    return _loadRouteData.apply(this, arguments);
  } // Utility wrapper for calling dataStrategy server-side without having to
  // pass around the manifest, mapRouteProperties, etc.
  function _loadRouteData() {
    _loadRouteData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
      var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
      return _regeneratorRuntime.wrap(function _callee18$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
              if (!(isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy))) {
                _context19.next = 3;
                break;
              }
              throw getInternalRouterError(400, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: routeMatch == null ? void 0 : routeMatch.route.id
              });
            case 3:
              requestMatches = routeMatch ? [routeMatch] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
              matchesToLoad = requestMatches.filter(function (m) {
                return m.route.loader || m.route.lazy;
              }); // Short circuit if we have no loaders to run (query())
              if (!(matchesToLoad.length === 0)) {
                _context19.next = 7;
                break;
              }
              return _context19.abrupt("return", {
                matches: matches,
                // Add a null for all matched routes for proper revalidation on the client
                loaderData: matches.reduce(function (acc, m) {
                  return Object.assign(acc, _defineProperty({}, m.route.id, null));
                }, {}),
                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? _defineProperty({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                statusCode: 200,
                loaderHeaders: {},
                activeDeferreds: null
              });
            case 7:
              _context19.next = 9;
              return callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
            case 9:
              results = _context19.sent;
              if (request.signal.aborted) {
                throwStaticHandlerAbortedError(request, isRouteRequest, future);
              }
              // Process and commit output from loaders
              activeDeferreds = new Map();
              context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling); // Add a null for any non-loader matches for proper revalidation on the client
              executedLoaders = new Set(matchesToLoad.map(function (match) {
                return match.route.id;
              }));
              matches.forEach(function (match) {
                if (!executedLoaders.has(match.route.id)) {
                  context.loaderData[match.route.id] = null;
                }
              });
              return _context19.abrupt("return", _extends({}, context, {
                matches: matches,
                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
              }));
            case 16:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee18);
    }));
    return _loadRouteData.apply(this, arguments);
  }
  function callDataStrategy(_x86, _x87, _x88, _x89, _x90, _x91, _x92) {
    return _callDataStrategy2.apply(this, arguments);
  }
  function _callDataStrategy2() {
    _callDataStrategy2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee20(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
      var results, dataResults;
      return _regeneratorRuntime.wrap(function _callee20$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
            case 2:
              results = _context21.sent;
              dataResults = {};
              _context21.next = 6;
              return Promise.all(matches.map(/*#__PURE__*/function () {
                var _ref19 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee19(match) {
                  var result, response;
                  return _regeneratorRuntime.wrap(function _callee19$(_context20) {
                    while (1) {
                      switch (_context20.prev = _context20.next) {
                        case 0:
                          if (match.route.id in results) {
                            _context20.next = 2;
                            break;
                          }
                          return _context20.abrupt("return");
                        case 2:
                          result = results[match.route.id];
                          if (!isRedirectDataStrategyResultResult(result)) {
                            _context20.next = 6;
                            break;
                          }
                          response = result.result; // Throw redirects and let the server handle them with an HTTP redirect
                          throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
                        case 6:
                          if (!(isResponse(result.result) && isRouteRequest)) {
                            _context20.next = 8;
                            break;
                          }
                          throw result;
                        case 8:
                          _context20.next = 10;
                          return convertDataStrategyResultToDataResult(result);
                        case 10:
                          dataResults[match.route.id] = _context20.sent;
                        case 11:
                        case "end":
                          return _context20.stop();
                      }
                    }
                  }, _callee19);
                }));
                return function (_x93) {
                  return _ref19.apply(this, arguments);
                };
              }()));
            case 6:
              return _context21.abrupt("return", dataResults);
            case 7:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee20);
    }));
    return _callDataStrategy2.apply(this, arguments);
  }
  return {
    dataRoutes: dataRoutes,
    query: query,
    queryRoute: queryRoute
  };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */
function getStaticContextFromError(routes, context, error) {
  var newContext = _extends({}, context, {
    statusCode: isRouteErrorResponse(error) ? error.status : 500,
    errors: _defineProperty({}, context._deepestRenderedBoundaryId || routes[0].id, error)
  });
  return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
  if (future.v7_throwAbortReason && request.signal.reason !== undefined) {
    throw request.signal.reason;
  }
  var method = isRouteRequest ? "queryRoute" : "query";
  throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
  return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
  var contextualMatches;
  var activeRouteMatch;
  if (fromRouteId) {
    // Grab matches up to the calling route so our route-relative logic is
    // relative to the correct source route
    contextualMatches = [];
    var _iterator5 = _createForOfIteratorHelper(matches),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var match = _step5.value;
        contextualMatches.push(match);
        if (match.route.id === fromRouteId) {
          activeRouteMatch = match;
          break;
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  } else {
    contextualMatches = matches;
    activeRouteMatch = matches[matches.length - 1];
  }
  // Resolve the relative path
  var path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
  // When `to` is not specified we inherit search/hash from the current
  // location, unlike when to="." and we just inherit the path.
  // See https://github.com/remix-run/remix/issues/927
  if (to == null) {
    path.search = location.search;
    path.hash = location.hash;
  }
  // Account for `?index` params when routing to the current location
  if ((to == null || to === "" || to === ".") && activeRouteMatch) {
    var nakedIndex = hasNakedIndexQuery(path.search);
    if (activeRouteMatch.route.index && !nakedIndex) {
      // Add one when we're targeting an index route
      path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    } else if (!activeRouteMatch.route.index && nakedIndex) {
      // Remove existing ones when we're not
      var params = new URLSearchParams(path.search);
      var indexValues = params.getAll("index");
      params.delete("index");
      indexValues.filter(function (v) {
        return v;
      }).forEach(function (v) {
        return params.append("index", v);
      });
      var qs = params.toString();
      path.search = qs ? "?" + qs : "";
    }
  }
  // If we're operating within a basename, prepend it to the pathname.  If
  // this is a root navigation, then just use the raw basename which allows
  // the basename to have full control over the presence of a trailing slash
  // on root actions
  if (prependBasename && basename !== "/") {
    path.pathname = path.pathname === "/" ? basename : joinPaths([basename, path.pathname]);
  }
  return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
  // Return location verbatim on non-submission navigations
  if (!opts || !isSubmissionNavigation(opts)) {
    return {
      path: path
    };
  }
  if (opts.formMethod && !isValidMethod(opts.formMethod)) {
    return {
      path: path,
      error: getInternalRouterError(405, {
        method: opts.formMethod
      })
    };
  }
  var getInvalidBodyError = function getInvalidBodyError() {
    return {
      path: path,
      error: getInternalRouterError(400, {
        type: "invalid-body"
      })
    };
  };
  // Create a Submission on non-GET navigations
  var rawFormMethod = opts.formMethod || "get";
  var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
  var formAction = stripHashFromPath(path);
  if (opts.body !== undefined) {
    if (opts.formEncType === "text/plain") {
      // text only support POST/PUT/PATCH/DELETE submissions
      if (!isMutationMethod(formMethod)) {
        return getInvalidBodyError();
      }
      var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ?
      // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
      Array.from(opts.body.entries()).reduce(function (acc, _ref3) {
        var _ref20 = _slicedToArray(_ref3, 2),
          name = _ref20[0],
          value = _ref20[1];
        return "" + acc + name + "=" + value + "\n";
      }, "") : String(opts.body);
      return {
        path: path,
        submission: {
          formMethod: formMethod,
          formAction: formAction,
          formEncType: opts.formEncType,
          formData: undefined,
          json: undefined,
          text: text
        }
      };
    } else if (opts.formEncType === "application/json") {
      // json only supports POST/PUT/PATCH/DELETE submissions
      if (!isMutationMethod(formMethod)) {
        return getInvalidBodyError();
      }
      try {
        var _json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
        return {
          path: path,
          submission: {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: opts.formEncType,
            formData: undefined,
            json: _json,
            text: undefined
          }
        };
      } catch (e) {
        return getInvalidBodyError();
      }
    }
  }
  invariant(typeof FormData === "function", "FormData is not available in this environment");
  var searchParams;
  var formData;
  if (opts.formData) {
    searchParams = convertFormDataToSearchParams(opts.formData);
    formData = opts.formData;
  } else if (opts.body instanceof FormData) {
    searchParams = convertFormDataToSearchParams(opts.body);
    formData = opts.body;
  } else if (opts.body instanceof URLSearchParams) {
    searchParams = opts.body;
    formData = convertSearchParamsToFormData(searchParams);
  } else if (opts.body == null) {
    searchParams = new URLSearchParams();
    formData = new FormData();
  } else {
    try {
      searchParams = new URLSearchParams(opts.body);
      formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
      return getInvalidBodyError();
    }
  }
  var submission = {
    formMethod: formMethod,
    formAction: formAction,
    formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
    formData: formData,
    json: undefined,
    text: undefined
  };
  if (isMutationMethod(submission.formMethod)) {
    return {
      path: path,
      submission: submission
    };
  }
  // Flatten submission onto URLSearchParams for GET submissions
  var parsedPath = parsePath(path);
  // On GET navigation submissions we can drop the ?index param from the
  // resulting location since all loaders will run.  But fetcher GET submissions
  // only run a single loader so we need to preserve any incoming ?index params
  if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) {
    searchParams.append("index", "");
  }
  parsedPath.search = "?" + searchParams;
  return {
    path: createPath(parsedPath),
    submission: submission
  };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
  if (includeBoundary === void 0) {
    includeBoundary = false;
  }
  var index = matches.findIndex(function (m) {
    return m.route.id === boundaryId;
  });
  if (index >= 0) {
    return matches.slice(0, includeBoundary ? index + 1 : index);
  }
  return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
  var actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
  var currentUrl = history.createURL(state.location);
  var nextUrl = history.createURL(location);
  // Pick navigation matches that are net-new or qualify for revalidation
  var boundaryMatches = matches;
  if (initialHydration && state.errors) {
    // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
  } else if (pendingActionResult && isErrorResult(pendingActionResult[1])) {
    // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
  }
  // Don't revalidate loaders by default after action 4xx/5xx responses
  // when the flag is enabled.  They can still opt-into revalidation via
  // `shouldRevalidate` via `actionResult`
  var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
  var shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
  var navigationMatches = boundaryMatches.filter(function (match, index) {
    var route = match.route;
    if (route.lazy) {
      // We haven't loaded this route yet so we don't know if it's got a loader!
      return true;
    }
    if (route.loader == null) {
      return false;
    }
    if (initialHydration) {
      return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
    }
    // Always call the loader on new route instances and pending defer cancellations
    if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function (id) {
      return id === match.route.id;
    })) {
      return true;
    }
    // This is the default implementation for when we revalidate.  If the route
    // provides it's own implementation, then we give them full control but
    // provide this value so they can leverage it if needed after they check
    // their own specific use cases
    var currentRouteMatch = state.matches[index];
    var nextRouteMatch = match;
    return shouldRevalidateLoader(match, _extends({
      currentUrl: currentUrl,
      currentParams: currentRouteMatch.params,
      nextUrl: nextUrl,
      nextParams: nextRouteMatch.params
    }, submission, {
      actionResult: actionResult,
      actionStatus: actionStatus,
      defaultShouldRevalidate: shouldSkipRevalidation ? false :
      // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
      isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search ||
      // Search params affect all loaders
      currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
    }));
  });
  // Pick fetcher.loads that need to be revalidated
  var revalidatingFetchers = [];
  fetchLoadMatches.forEach(function (f, key) {
    // Don't revalidate:
    //  - on initial hydration (shouldn't be any fetchers then anyway)
    //  - if fetcher won't be present in the subsequent render
    //    - no longer matches the URL (v7_fetcherPersist=false)
    //    - was unmounted but persisted due to v7_fetcherPersist=true
    if (initialHydration || !matches.some(function (m) {
      return m.route.id === f.routeId;
    }) || deletedFetchers.has(key)) {
      return;
    }
    var fetcherMatches = matchRoutes(routesToUse, f.path, basename);
    // If the fetcher path no longer matches, push it in with null matches so
    // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
    // currently only a use-case for Remix HMR where the route tree can change
    // at runtime and remove a route previously loaded via a fetcher
    if (!fetcherMatches) {
      revalidatingFetchers.push({
        key: key,
        routeId: f.routeId,
        path: f.path,
        matches: null,
        match: null,
        controller: null
      });
      return;
    }
    // Revalidating fetchers are decoupled from the route matches since they
    // load from a static href.  They revalidate based on explicit revalidation
    // (submission, useRevalidator, or X-Remix-Revalidate)
    var fetcher = state.fetchers.get(key);
    var fetcherMatch = getTargetMatch(fetcherMatches, f.path);
    var shouldRevalidate = false;
    if (fetchRedirectIds.has(key)) {
      // Never trigger a revalidation of an actively redirecting fetcher
      shouldRevalidate = false;
    } else if (cancelledFetcherLoads.has(key)) {
      // Always mark for revalidation if the fetcher was cancelled
      cancelledFetcherLoads.delete(key);
      shouldRevalidate = true;
    } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) {
      // If the fetcher hasn't ever completed loading yet, then this isn't a
      // revalidation, it would just be a brand new load if an explicit
      // revalidation is required
      shouldRevalidate = isRevalidationRequired;
    } else {
      // Otherwise fall back on any user-defined shouldRevalidate, defaulting
      // to explicit revalidations only
      shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
        currentUrl: currentUrl,
        currentParams: state.matches[state.matches.length - 1].params,
        nextUrl: nextUrl,
        nextParams: matches[matches.length - 1].params
      }, submission, {
        actionResult: actionResult,
        actionStatus: actionStatus,
        defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
      }));
    }
    if (shouldRevalidate) {
      revalidatingFetchers.push({
        key: key,
        routeId: f.routeId,
        path: f.path,
        matches: fetcherMatches,
        match: fetcherMatch,
        controller: new AbortController()
      });
    }
  });
  return [navigationMatches, revalidatingFetchers];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
  // We dunno if we have a loader - gotta find out!
  if (route.lazy) {
    return true;
  }
  // No loader, nothing to initialize
  if (!route.loader) {
    return false;
  }
  var hasData = loaderData != null && loaderData[route.id] !== undefined;
  var hasError = errors != null && errors[route.id] !== undefined;
  // Don't run if we error'd during SSR
  if (!hasData && hasError) {
    return false;
  }
  // Explicitly opting-in to running on hydration
  if (typeof route.loader === "function" && route.loader.hydrate === true) {
    return true;
  }
  // Otherwise, run if we're not yet initialized with anything
  return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
  var isNew =
  // [a] -> [a, b]
  !currentMatch ||
  // [a, b] -> [a, c]
  match.route.id !== currentMatch.route.id;
  // Handle the case that we don't have data for a re-used route, potentially
  // from a prior error or from a cancelled pending deferred
  var isMissingData = currentLoaderData[match.route.id] === undefined;
  // Always load if this is a net-new route or we don't yet have data
  return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
  var currentPath = currentMatch.route.path;
  return (
    // param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname ||
    // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]
  );
}
function shouldRevalidateLoader(loaderMatch, arg) {
  if (loaderMatch.route.shouldRevalidate) {
    var routeChoice = loaderMatch.route.shouldRevalidate(arg);
    if (typeof routeChoice === "boolean") {
      return routeChoice;
    }
  }
  return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
  var _childrenToPatch2;
  var _childrenToPatch;
  var childrenToPatch;
  if (routeId) {
    var route = manifest[routeId];
    invariant(route, "No route found to patch children into: routeId = " + routeId);
    if (!route.children) {
      route.children = [];
    }
    childrenToPatch = route.children;
  } else {
    childrenToPatch = routesToUse;
  }
  // Don't patch in routes we already know about so that `patch` is idempotent
  // to simplify user-land code. This is useful because we re-call the
  // `patchRoutesOnNavigation` function for matched routes with params.
  var uniqueChildren = children.filter(function (newRoute) {
    return !childrenToPatch.some(function (existingRoute) {
      return isSameRoute(newRoute, existingRoute);
    });
  });
  var newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties, [routeId || "_", "patch", String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")], manifest);
  (_childrenToPatch2 = childrenToPatch).push.apply(_childrenToPatch2, _toConsumableArray(newRoutes));
}
function isSameRoute(newRoute, existingRoute) {
  // Most optimal check is by id
  if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) {
    return true;
  }
  // Second is by pathing differences
  if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) {
    return false;
  }
  // Pathless layout routes are trickier since we need to check children.
  // If they have no children then they're the same as far as we can tell
  if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) {
    return true;
  }
  // Otherwise, we look to see if every child in the new route is already
  // represented in the existing route's children
  return newRoute.children.every(function (aChild, i) {
    var _existingRoute$childr;
    return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some(function (bChild) {
      return isSameRoute(aChild, bChild);
    });
  });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */
function loadLazyRouteModule(_x94, _x95, _x96) {
  return _loadLazyRouteModule.apply(this, arguments);
} // Default implementation of `dataStrategy` which fetches all loaders in parallel
function _loadLazyRouteModule() {
  _loadLazyRouteModule = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee21(route, mapRouteProperties, manifest) {
    var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
    return _regeneratorRuntime.wrap(function _callee21$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            if (route.lazy) {
              _context22.next = 2;
              break;
            }
            return _context22.abrupt("return");
          case 2:
            _context22.next = 4;
            return route.lazy();
          case 4:
            lazyRoute = _context22.sent;
            if (route.lazy) {
              _context22.next = 7;
              break;
            }
            return _context22.abrupt("return");
          case 7:
            routeToUpdate = manifest[route.id];
            invariant(routeToUpdate, "No route found in manifest");
            // Update the route in place.  This should be safe because there's no way
            // we could yet be sitting on this route as we can't get there without
            // resolving lazy() first.
            //
            // This is different than the HMR "update" use-case where we may actively be
            // on the route being updated.  The main concern boils down to "does this
            // mutation affect any ongoing navigations or any current state.matches
            // values?".  If not, it should be safe to update in place.
            routeUpdates = {};
            for (lazyRouteProperty in lazyRoute) {
              staticRouteValue = routeToUpdate[lazyRouteProperty];
              isPropertyStaticallyDefined = staticRouteValue !== undefined &&
              // This property isn't static since it should always be updated based
              // on the route updates
              lazyRouteProperty !== "hasErrorBoundary";
              warning(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
              if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) {
                routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
              }
            }
            // Mutate the route with the provided updates.  Do this first so we pass
            // the updated version to mapRouteProperties
            Object.assign(routeToUpdate, routeUpdates);
            // Mutate the `hasErrorBoundary` property on the route based on the route
            // updates and remove the `lazy` function so we don't resolve the lazy
            // route again.
            Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
              lazy: undefined
            }));
          case 13:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee21);
  }));
  return _loadLazyRouteModule.apply(this, arguments);
}
function defaultDataStrategy(_x97) {
  return _defaultDataStrategy.apply(this, arguments);
}
function _defaultDataStrategy() {
  _defaultDataStrategy = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee22(_ref4) {
    var matches, matchesToLoad, results;
    return _regeneratorRuntime.wrap(function _callee22$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            matches = _ref4.matches;
            matchesToLoad = matches.filter(function (m) {
              return m.shouldLoad;
            });
            _context23.next = 4;
            return Promise.all(matchesToLoad.map(function (m) {
              return m.resolve();
            }));
          case 4:
            results = _context23.sent;
            return _context23.abrupt("return", results.reduce(function (acc, result, i) {
              return Object.assign(acc, _defineProperty({}, matchesToLoad[i].route.id, result));
            }, {}));
          case 6:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee22);
  }));
  return _defaultDataStrategy.apply(this, arguments);
}
function callDataStrategyImpl(_x98, _x99, _x100, _x101, _x102, _x103, _x104, _x105, _x106, _x107) {
  return _callDataStrategyImpl.apply(this, arguments);
} // Default logic for calling a loader/action is the user has no specified a dataStrategy
function _callDataStrategyImpl() {
  _callDataStrategyImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee24(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    var loadRouteDefinitionsPromises, dsMatches, results;
    return _regeneratorRuntime.wrap(function _callee24$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            loadRouteDefinitionsPromises = matches.map(function (m) {
              return m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined;
            });
            dsMatches = matches.map(function (match, i) {
              var loadRoutePromise = loadRouteDefinitionsPromises[i];
              var shouldLoad = matchesToLoad.some(function (m) {
                return m.route.id === match.route.id;
              });
              // `resolve` encapsulates route.lazy(), executing the loader/action,
              // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
              // can pass a callback to take fine-grained control over the execution
              // of the loader/action
              var resolve = /*#__PURE__*/function () {
                var _ref22 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee23(handlerOverride) {
                  return _regeneratorRuntime.wrap(function _callee23$(_context24) {
                    while (1) {
                      switch (_context24.prev = _context24.next) {
                        case 0:
                          if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) {
                            shouldLoad = true;
                          }
                          return _context24.abrupt("return", shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                            type: ResultType.data,
                            result: undefined
                          }));
                        case 2:
                        case "end":
                          return _context24.stop();
                      }
                    }
                  }, _callee23);
                }));
                return function resolve(_x126) {
                  return _ref22.apply(this, arguments);
                };
              }();
              return _extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
              });
            }); // Send all matches here to allow for a middleware-type implementation.
            // handler will be a no-op for unneeded routes and we filter those results
            // back out below.
            _context25.next = 4;
            return dataStrategyImpl({
              matches: dsMatches,
              request: request,
              params: matches[0].params,
              fetcherKey: fetcherKey,
              context: requestContext
            });
          case 4:
            results = _context25.sent;
            _context25.prev = 5;
            _context25.next = 8;
            return Promise.all(loadRouteDefinitionsPromises);
          case 8:
            _context25.next = 12;
            break;
          case 10:
            _context25.prev = 10;
            _context25.t0 = _context25["catch"](5);
          case 12:
            return _context25.abrupt("return", results);
          case 13:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee24, null, [[5, 10]]);
  }));
  return _callDataStrategyImpl.apply(this, arguments);
}
function callLoaderOrAction(_x108, _x109, _x110, _x111, _x112, _x113) {
  return _callLoaderOrAction.apply(this, arguments);
}
function _callLoaderOrAction() {
  _callLoaderOrAction = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee26(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    var result, onReject, runHandler, handler, handlerError, _yield$Promise$all, _yield$Promise$all2, value, url, pathname, _url, _pathname;
    return _regeneratorRuntime.wrap(function _callee26$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            runHandler = function runHandler(handler) {
              // Setup a promise we can race against so that abort signals short circuit
              var reject;
              // This will never resolve so safe to type it as Promise<DataStrategyResult> to
              // satisfy the function return value
              var abortPromise = new Promise(function (_, r) {
                return reject = r;
              });
              onReject = function onReject() {
                return reject();
              };
              request.signal.addEventListener("abort", onReject);
              var actualHandler = function actualHandler(ctx) {
                if (typeof handler !== "function") {
                  return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
                }
                return handler.apply(void 0, [{
                  request: request,
                  params: match.params,
                  context: staticContext
                }].concat(_toConsumableArray(ctx !== undefined ? [ctx] : [])));
              };
              var handlerPromise = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
                var val;
                return _regeneratorRuntime.wrap(function _callee25$(_context26) {
                  while (1) {
                    switch (_context26.prev = _context26.next) {
                      case 0:
                        _context26.prev = 0;
                        _context26.next = 3;
                        return handlerOverride ? handlerOverride(function (ctx) {
                          return actualHandler(ctx);
                        }) : actualHandler();
                      case 3:
                        val = _context26.sent;
                        return _context26.abrupt("return", {
                          type: "data",
                          result: val
                        });
                      case 7:
                        _context26.prev = 7;
                        _context26.t0 = _context26["catch"](0);
                        return _context26.abrupt("return", {
                          type: "error",
                          result: _context26.t0
                        });
                      case 10:
                      case "end":
                        return _context26.stop();
                    }
                  }
                }, _callee25, null, [[0, 7]]);
              }))();
              return Promise.race([handlerPromise, abortPromise]);
            };
            _context27.prev = 1;
            handler = match.route[type]; // If we have a route.lazy promise, await that first
            if (!loadRoutePromise) {
              _context27.next = 33;
              break;
            }
            if (!handler) {
              _context27.next = 15;
              break;
            }
            _context27.next = 7;
            return Promise.all([
            // If the handler throws, don't let it immediately bubble out,
            // since we need to let the lazy() execution finish so we know if this
            // route has a boundary that can handle the error
            runHandler(handler).catch(function (e) {
              handlerError = e;
            }), loadRoutePromise]);
          case 7:
            _yield$Promise$all = _context27.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
            value = _yield$Promise$all2[0];
            if (!(handlerError !== undefined)) {
              _context27.next = 12;
              break;
            }
            throw handlerError;
          case 12:
            result = value;
            _context27.next = 31;
            break;
          case 15:
            _context27.next = 17;
            return loadRoutePromise;
          case 17:
            handler = match.route[type];
            if (!handler) {
              _context27.next = 24;
              break;
            }
            _context27.next = 21;
            return runHandler(handler);
          case 21:
            result = _context27.sent;
            _context27.next = 31;
            break;
          case 24:
            if (!(type === "action")) {
              _context27.next = 30;
              break;
            }
            url = new URL(request.url);
            pathname = url.pathname + url.search;
            throw getInternalRouterError(405, {
              method: request.method,
              pathname: pathname,
              routeId: match.route.id
            });
          case 30:
            return _context27.abrupt("return", {
              type: ResultType.data,
              result: undefined
            });
          case 31:
            _context27.next = 42;
            break;
          case 33:
            if (handler) {
              _context27.next = 39;
              break;
            }
            _url = new URL(request.url);
            _pathname = _url.pathname + _url.search;
            throw getInternalRouterError(404, {
              pathname: _pathname
            });
          case 39:
            _context27.next = 41;
            return runHandler(handler);
          case 41:
            result = _context27.sent;
          case 42:
            invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
            _context27.next = 48;
            break;
          case 45:
            _context27.prev = 45;
            _context27.t0 = _context27["catch"](1);
            return _context27.abrupt("return", {
              type: ResultType.error,
              result: _context27.t0
            });
          case 48:
            _context27.prev = 48;
            if (onReject) {
              request.signal.removeEventListener("abort", onReject);
            }
            return _context27.finish(48);
          case 51:
            return _context27.abrupt("return", result);
          case 52:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee26, null, [[1, 45, 48, 51]]);
  }));
  return _callLoaderOrAction.apply(this, arguments);
}
function convertDataStrategyResultToDataResult(_x114) {
  return _convertDataStrategyResultToDataResult.apply(this, arguments);
} // Support relative routing in internal redirects
function _convertDataStrategyResultToDataResult() {
  _convertDataStrategyResultToDataResult = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee27(dataStrategyResult) {
    var result, type, _data2, contentType, _result$init2, _result$init, _result$init3, _result$init4, _result$init5, _result$init6;
    return _regeneratorRuntime.wrap(function _callee27$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            result = dataStrategyResult.result, type = dataStrategyResult.type;
            if (!isResponse(result)) {
              _context28.next = 25;
              break;
            }
            _context28.prev = 2;
            contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (!(contentType && /\bapplication\/json\b/.test(contentType))) {
              _context28.next = 14;
              break;
            }
            if (!(result.body == null)) {
              _context28.next = 9;
              break;
            }
            _data2 = null;
            _context28.next = 12;
            break;
          case 9:
            _context28.next = 11;
            return result.json();
          case 11:
            _data2 = _context28.sent;
          case 12:
            _context28.next = 17;
            break;
          case 14:
            _context28.next = 16;
            return result.text();
          case 16:
            _data2 = _context28.sent;
          case 17:
            _context28.next = 22;
            break;
          case 19:
            _context28.prev = 19;
            _context28.t0 = _context28["catch"](2);
            return _context28.abrupt("return", {
              type: ResultType.error,
              error: _context28.t0
            });
          case 22:
            if (!(type === ResultType.error)) {
              _context28.next = 24;
              break;
            }
            return _context28.abrupt("return", {
              type: ResultType.error,
              error: new ErrorResponseImpl(result.status, result.statusText, _data2),
              statusCode: result.status,
              headers: result.headers
            });
          case 24:
            return _context28.abrupt("return", {
              type: ResultType.data,
              data: _data2,
              statusCode: result.status,
              headers: result.headers
            });
          case 25:
            if (!(type === ResultType.error)) {
              _context28.next = 31;
              break;
            }
            if (!isDataWithResponseInit(result)) {
              _context28.next = 30;
              break;
            }
            if (!(result.data instanceof Error)) {
              _context28.next = 29;
              break;
            }
            return _context28.abrupt("return", {
              type: ResultType.error,
              error: result.data,
              statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
            });
          case 29:
            // Convert thrown data() to ErrorResponse instances
            result = new ErrorResponseImpl(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
          case 30:
            return _context28.abrupt("return", {
              type: ResultType.error,
              error: result,
              statusCode: isRouteErrorResponse(result) ? result.status : undefined
            });
          case 31:
            if (!isDeferredData(result)) {
              _context28.next = 33;
              break;
            }
            return _context28.abrupt("return", {
              type: ResultType.deferred,
              deferredData: result,
              statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
              headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
            });
          case 33:
            if (!isDataWithResponseInit(result)) {
              _context28.next = 35;
              break;
            }
            return _context28.abrupt("return", {
              type: ResultType.data,
              data: result.data,
              statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
              headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
            });
          case 35:
            return _context28.abrupt("return", {
              type: ResultType.data,
              data: result
            });
          case 36:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee27, null, [[2, 19]]);
  }));
  return _convertDataStrategyResultToDataResult.apply(this, arguments);
}
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
  var location = response.headers.get("Location");
  invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
  if (!ABSOLUTE_URL_REGEX.test(location)) {
    var trimmedMatches = matches.slice(0, matches.findIndex(function (m) {
      return m.route.id === routeId;
    }) + 1);
    location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
    response.headers.set("Location", location);
  }
  return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
  if (ABSOLUTE_URL_REGEX.test(location)) {
    // Strip off the protocol+origin for same-origin + same-basename absolute redirects
    var normalizedLocation = location;
    var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
    var isSameBasename = stripBasename(url.pathname, basename) != null;
    if (url.origin === currentUrl.origin && isSameBasename) {
      return url.pathname + url.search + url.hash;
    }
  }
  return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
  var url = history.createURL(stripHashFromPath(location)).toString();
  var init = {
    signal: signal
  };
  if (submission && isMutationMethod(submission.formMethod)) {
    var formMethod = submission.formMethod,
      formEncType = submission.formEncType; // Didn't think we needed this but it turns out unlike other methods, patch
    // won't be properly normalized to uppercase and results in a 405 error.
    // See: https://fetch.spec.whatwg.org/#concept-method
    init.method = formMethod.toUpperCase();
    if (formEncType === "application/json") {
      init.headers = new Headers({
        "Content-Type": formEncType
      });
      init.body = JSON.stringify(submission.json);
    } else if (formEncType === "text/plain") {
      // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
      init.body = submission.text;
    } else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) {
      // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
      init.body = convertFormDataToSearchParams(submission.formData);
    } else {
      // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
      init.body = submission.formData;
    }
  }
  return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
  var searchParams = new URLSearchParams();
  var _iterator6 = _createForOfIteratorHelper(formData.entries()),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var _step6$value = _slicedToArray(_step6.value, 2),
        key = _step6$value[0],
        value = _step6$value[1];
      // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
      searchParams.append(key, typeof value === "string" ? value : value.name);
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
  var formData = new FormData();
  var _iterator7 = _createForOfIteratorHelper(searchParams.entries()),
    _step7;
  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var _step7$value = _slicedToArray(_step7.value, 2),
        key = _step7$value[0],
        value = _step7$value[1];
      formData.append(key, value);
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
  return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
  // Fill in loaderData/errors from our loaders
  var loaderData = {};
  var errors = null;
  var statusCode;
  var foundError = false;
  var loaderHeaders = {};
  var pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
  // Process loader results into state.loaderData/state.errors
  matches.forEach(function (match) {
    if (!(match.route.id in results)) {
      return;
    }
    var id = match.route.id;
    var result = results[id];
    invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
    if (isErrorResult(result)) {
      var error = result.error;
      // If we have a pending action error, we report it at the highest-route
      // that throws a loader error, and then clear it out to indicate that
      // it was consumed
      if (pendingError !== undefined) {
        error = pendingError;
        pendingError = undefined;
      }
      errors = errors || {};
      if (skipLoaderErrorBubbling) {
        errors[id] = error;
      } else {
        // Look upwards from the matched route for the closest ancestor error
        // boundary, defaulting to the root match.  Prefer higher error values
        // if lower errors bubble to the same boundary
        var boundaryMatch = findNearestBoundary(matches, id);
        if (errors[boundaryMatch.route.id] == null) {
          errors[boundaryMatch.route.id] = error;
        }
      }
      // Clear our any prior loaderData for the throwing route
      loaderData[id] = undefined;
      // Once we find our first (highest) error, we set the status code and
      // prevent deeper status codes from overriding
      if (!foundError) {
        foundError = true;
        statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
      }
      if (result.headers) {
        loaderHeaders[id] = result.headers;
      }
    } else {
      if (isDeferredResult(result)) {
        activeDeferreds.set(id, result.deferredData);
        loaderData[id] = result.deferredData.data;
        // Error status codes always override success status codes, but if all
        // loaders are successful we take the deepest status code.
        if (result.statusCode != null && result.statusCode !== 200 && !foundError) {
          statusCode = result.statusCode;
        }
        if (result.headers) {
          loaderHeaders[id] = result.headers;
        }
      } else {
        loaderData[id] = result.data;
        // Error status codes always override success status codes, but if all
        // loaders are successful we take the deepest status code.
        if (result.statusCode && result.statusCode !== 200 && !foundError) {
          statusCode = result.statusCode;
        }
        if (result.headers) {
          loaderHeaders[id] = result.headers;
        }
      }
    }
  });
  // If we didn't consume the pending action error (i.e., all loaders
  // resolved), then consume it here.  Also clear out any loaderData for the
  // throwing route
  if (pendingError !== undefined && pendingActionResult) {
    errors = _defineProperty({}, pendingActionResult[0], pendingError);
    loaderData[pendingActionResult[0]] = undefined;
  }
  return {
    loaderData: loaderData,
    errors: errors,
    statusCode: statusCode || 200,
    loaderHeaders: loaderHeaders
  };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
  var _processRouteLoaderDa = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    ),
    loaderData = _processRouteLoaderDa.loaderData,
    errors = _processRouteLoaderDa.errors; // Process results from our revalidating fetchers
  revalidatingFetchers.forEach(function (rf) {
    var key = rf.key,
      match = rf.match,
      controller = rf.controller;
    var result = fetcherResults[key];
    invariant(result, "Did not find corresponding fetcher result");
    // Process fetcher non-redirect errors
    if (controller && controller.signal.aborted) {
      // Nothing to do for aborted fetchers
      return;
    } else if (isErrorResult(result)) {
      var boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
      if (!(errors && errors[boundaryMatch.route.id])) {
        errors = _extends({}, errors, _defineProperty({}, boundaryMatch.route.id, result.error));
      }
      state.fetchers.delete(key);
    } else if (isRedirectResult(result)) {
      // Should never get here, redirects should get processed above, but we
      // keep this to type narrow to a success result in the else
      invariant(false, "Unhandled fetcher revalidation redirect");
    } else if (isDeferredResult(result)) {
      // Should never get here, deferred data should be awaited for fetchers
      // in resolveDeferredResults
      invariant(false, "Unhandled fetcher deferred data");
    } else {
      var doneFetcher = getDoneFetcher(result.data);
      state.fetchers.set(key, doneFetcher);
    }
  });
  return {
    loaderData: loaderData,
    errors: errors
  };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
  var mergedLoaderData = _extends({}, newLoaderData);
  var _iterator8 = _createForOfIteratorHelper(matches),
    _step8;
  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var match = _step8.value;
      var id = match.route.id;
      if (newLoaderData.hasOwnProperty(id)) {
        if (newLoaderData[id] !== undefined) {
          mergedLoaderData[id] = newLoaderData[id];
        }
      } else if (loaderData[id] !== undefined && match.route.loader) {
        // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
      }
      if (errors && errors.hasOwnProperty(id)) {
        // Don't keep any loader data below the boundary
        break;
      }
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
  return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
  if (!pendingActionResult) {
    return {};
  }
  return isErrorResult(pendingActionResult[1]) ? {
    // Clear out prior actionData on errors
    actionData: {}
  } : {
    actionData: _defineProperty({}, pendingActionResult[0], pendingActionResult[1].data)
  };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
  var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function (m) {
    return m.route.id === routeId;
  }) + 1) : _toConsumableArray(matches);
  return eligibleMatches.reverse().find(function (m) {
    return m.route.hasErrorBoundary === true;
  }) || matches[0];
}
function getShortCircuitMatches(routes) {
  // Prefer a root layout route if present, otherwise shim in a route object
  var route = routes.length === 1 ? routes[0] : routes.find(function (r) {
    return r.index || !r.path || r.path === "/";
  }) || {
    id: "__shim-error-route__"
  };
  return {
    matches: [{
      params: {},
      pathname: "",
      pathnameBase: "",
      route: route
    }],
    route: route
  };
}
function getInternalRouterError(status, _temp5) {
  var _ref21 = _temp5 === void 0 ? {} : _temp5,
    pathname = _ref21.pathname,
    routeId = _ref21.routeId,
    method = _ref21.method,
    type = _ref21.type,
    message = _ref21.message;
  var statusText = "Unknown Server Error";
  var errorMessage = "Unknown @remix-run/router error";
  if (status === 400) {
    statusText = "Bad Request";
    if (method && pathname && routeId) {
      errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
    } else if (type === "defer-action") {
      errorMessage = "defer() is not supported in actions";
    } else if (type === "invalid-body") {
      errorMessage = "Unable to encode submission body";
    }
  } else if (status === 403) {
    statusText = "Forbidden";
    errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
  } else if (status === 404) {
    statusText = "Not Found";
    errorMessage = "No route matches URL \"" + pathname + "\"";
  } else if (status === 405) {
    statusText = "Method Not Allowed";
    if (method && pathname && routeId) {
      errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
    } else if (method) {
      errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
  }
  return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
  var entries = Object.entries(results);
  for (var i = entries.length - 1; i >= 0; i--) {
    var _entries$i = _slicedToArray(entries[i], 2),
      key = _entries$i[0],
      result = _entries$i[1];
    if (isRedirectResult(result)) {
      return {
        key: key,
        result: result
      };
    }
  }
}
function stripHashFromPath(path) {
  var parsedPath = typeof path === "string" ? parsePath(path) : path;
  return createPath(_extends({}, parsedPath, {
    hash: ""
  }));
}
function isHashChangeOnly(a, b) {
  if (a.pathname !== b.pathname || a.search !== b.search) {
    return false;
  }
  if (a.hash === "") {
    // /page -> /page#hash
    return b.hash !== "";
  } else if (a.hash === b.hash) {
    // /page#hash -> /page#hash
    return true;
  } else if (b.hash !== "") {
    // /page#hash -> /page#other
    return true;
  }
  // If the hash is removed the browser will re-perform a request to the server
  // /page#hash -> /page
  return false;
}
function isDataStrategyResult(result) {
  return result != null && _typeof(result) === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
  return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
  return result.type === ResultType.deferred;
}
function isErrorResult(result) {
  return result.type === ResultType.error;
}
function isRedirectResult(result) {
  return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
  return _typeof(value) === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
  var deferred = value;
  return deferred && _typeof(deferred) === "object" && _typeof(deferred.data) === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
  return value != null && typeof value.status === "number" && typeof value.statusText === "string" && _typeof(value.headers) === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
  if (!isResponse(result)) {
    return false;
  }
  var status = result.status;
  var location = result.headers.get("Location");
  return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
  return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
  return validMutationMethods.has(method.toLowerCase());
}
function resolveNavigationDeferredResults(_x115, _x116, _x117, _x118, _x119) {
  return _resolveNavigationDeferredResults.apply(this, arguments);
}
function _resolveNavigationDeferredResults() {
  _resolveNavigationDeferredResults = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee29(matches, results, signal, currentMatches, currentLoaderData) {
    var entries, _loop2, index, _ret2;
    return _regeneratorRuntime.wrap(function _callee29$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            entries = Object.entries(results);
            _loop2 = /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(index) {
              var _entries$index, routeId, result, match, currentMatch, isRevalidatingLoader;
              return _regeneratorRuntime.wrap(function _callee28$(_context29) {
                while (1) {
                  switch (_context29.prev = _context29.next) {
                    case 0:
                      _entries$index = _slicedToArray(entries[index], 2), routeId = _entries$index[0], result = _entries$index[1];
                      match = matches.find(function (m) {
                        return (m == null ? void 0 : m.route.id) === routeId;
                      }); // If we don't have a match, then we can have a deferred result to do
                      // anything with.  This is for revalidating fetchers where the route was
                      // removed during HMR
                      if (match) {
                        _context29.next = 4;
                        break;
                      }
                      return _context29.abrupt("return", "continue");
                    case 4:
                      currentMatch = currentMatches.find(function (m) {
                        return m.route.id === match.route.id;
                      });
                      isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                      if (!(isDeferredResult(result) && isRevalidatingLoader)) {
                        _context29.next = 9;
                        break;
                      }
                      _context29.next = 9;
                      return resolveDeferredData(result, signal, false).then(function (result) {
                        if (result) {
                          results[routeId] = result;
                        }
                      });
                    case 9:
                    case "end":
                      return _context29.stop();
                  }
                }
              }, _callee28);
            });
            index = 0;
          case 3:
            if (!(index < entries.length)) {
              _context30.next = 11;
              break;
            }
            return _context30.delegateYield(_loop2(index), "t0", 5);
          case 5:
            _ret2 = _context30.t0;
            if (!(_ret2 === "continue")) {
              _context30.next = 8;
              break;
            }
            return _context30.abrupt("continue", 8);
          case 8:
            index++;
            _context30.next = 3;
            break;
          case 11:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee29);
  }));
  return _resolveNavigationDeferredResults.apply(this, arguments);
}
function resolveFetcherDeferredResults(_x120, _x121, _x122) {
  return _resolveFetcherDeferredResults.apply(this, arguments);
}
function _resolveFetcherDeferredResults() {
  _resolveFetcherDeferredResults = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee31(matches, results, revalidatingFetchers) {
    var _loop3, index, _ret3;
    return _regeneratorRuntime.wrap(function _callee31$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            _loop3 = /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(index) {
              var _revalidatingFetchers, key, routeId, controller, result, match;
              return _regeneratorRuntime.wrap(function _callee30$(_context31) {
                while (1) {
                  switch (_context31.prev = _context31.next) {
                    case 0:
                      _revalidatingFetchers = revalidatingFetchers[index], key = _revalidatingFetchers.key, routeId = _revalidatingFetchers.routeId, controller = _revalidatingFetchers.controller;
                      result = results[key];
                      match = matches.find(function (m) {
                        return (m == null ? void 0 : m.route.id) === routeId;
                      }); // If we don't have a match, then we can have a deferred result to do
                      // anything with.  This is for revalidating fetchers where the route was
                      // removed during HMR
                      if (match) {
                        _context31.next = 5;
                        break;
                      }
                      return _context31.abrupt("return", "continue");
                    case 5:
                      if (!isDeferredResult(result)) {
                        _context31.next = 9;
                        break;
                      }
                      // Note: we do not have to touch activeDeferreds here since we race them
                      // against the signal in resolveDeferredData and they'll get aborted
                      // there if needed
                      invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
                      _context31.next = 9;
                      return resolveDeferredData(result, controller.signal, true).then(function (result) {
                        if (result) {
                          results[key] = result;
                        }
                      });
                    case 9:
                    case "end":
                      return _context31.stop();
                  }
                }
              }, _callee30);
            });
            index = 0;
          case 2:
            if (!(index < revalidatingFetchers.length)) {
              _context32.next = 10;
              break;
            }
            return _context32.delegateYield(_loop3(index), "t0", 4);
          case 4:
            _ret3 = _context32.t0;
            if (!(_ret3 === "continue")) {
              _context32.next = 7;
              break;
            }
            return _context32.abrupt("continue", 7);
          case 7:
            index++;
            _context32.next = 2;
            break;
          case 10:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee31);
  }));
  return _resolveFetcherDeferredResults.apply(this, arguments);
}
function resolveDeferredData(_x123, _x124, _x125) {
  return _resolveDeferredData.apply(this, arguments);
}
function _resolveDeferredData() {
  _resolveDeferredData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee32(result, signal, unwrap) {
    var aborted;
    return _regeneratorRuntime.wrap(function _callee32$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            if (unwrap === void 0) {
              unwrap = false;
            }
            _context33.next = 3;
            return result.deferredData.resolveData(signal);
          case 3:
            aborted = _context33.sent;
            if (!aborted) {
              _context33.next = 6;
              break;
            }
            return _context33.abrupt("return");
          case 6:
            if (!unwrap) {
              _context33.next = 14;
              break;
            }
            _context33.prev = 7;
            return _context33.abrupt("return", {
              type: ResultType.data,
              data: result.deferredData.unwrappedData
            });
          case 11:
            _context33.prev = 11;
            _context33.t0 = _context33["catch"](7);
            return _context33.abrupt("return", {
              type: ResultType.error,
              error: _context33.t0
            });
          case 14:
            return _context33.abrupt("return", {
              type: ResultType.data,
              data: result.deferredData.data
            });
          case 15:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee32, null, [[7, 11]]);
  }));
  return _resolveDeferredData.apply(this, arguments);
}
function hasNakedIndexQuery(search) {
  return new URLSearchParams(search).getAll("index").some(function (v) {
    return v === "";
  });
}
function getTargetMatch(matches, location) {
  var search = typeof location === "string" ? parsePath(location).search : location.search;
  if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) {
    // Return the leaf index route when index is present
    return matches[matches.length - 1];
  }
  // Otherwise grab the deepest "path contributing" match (ignoring index and
  // pathless layout routes)
  var pathMatches = getPathContributingMatches(matches);
  return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
  var formMethod = navigation.formMethod,
    formAction = navigation.formAction,
    formEncType = navigation.formEncType,
    text = navigation.text,
    formData = navigation.formData,
    json = navigation.json;
  if (!formMethod || !formAction || !formEncType) {
    return;
  }
  if (text != null) {
    return {
      formMethod: formMethod,
      formAction: formAction,
      formEncType: formEncType,
      formData: undefined,
      json: undefined,
      text: text
    };
  } else if (formData != null) {
    return {
      formMethod: formMethod,
      formAction: formAction,
      formEncType: formEncType,
      formData: formData,
      json: undefined,
      text: undefined
    };
  } else if (json !== undefined) {
    return {
      formMethod: formMethod,
      formAction: formAction,
      formEncType: formEncType,
      formData: undefined,
      json: json,
      text: undefined
    };
  }
}
function getLoadingNavigation(location, submission) {
  if (submission) {
    var navigation = {
      state: "loading",
      location: location,
      formMethod: submission.formMethod,
      formAction: submission.formAction,
      formEncType: submission.formEncType,
      formData: submission.formData,
      json: submission.json,
      text: submission.text
    };
    return navigation;
  } else {
    var _navigation = {
      state: "loading",
      location: location,
      formMethod: undefined,
      formAction: undefined,
      formEncType: undefined,
      formData: undefined,
      json: undefined,
      text: undefined
    };
    return _navigation;
  }
}
function getSubmittingNavigation(location, submission) {
  var navigation = {
    state: "submitting",
    location: location,
    formMethod: submission.formMethod,
    formAction: submission.formAction,
    formEncType: submission.formEncType,
    formData: submission.formData,
    json: submission.json,
    text: submission.text
  };
  return navigation;
}
function getLoadingFetcher(submission, data) {
  if (submission) {
    var fetcher = {
      state: "loading",
      formMethod: submission.formMethod,
      formAction: submission.formAction,
      formEncType: submission.formEncType,
      formData: submission.formData,
      json: submission.json,
      text: submission.text,
      data: data
    };
    return fetcher;
  } else {
    var _fetcher = {
      state: "loading",
      formMethod: undefined,
      formAction: undefined,
      formEncType: undefined,
      formData: undefined,
      json: undefined,
      text: undefined,
      data: data
    };
    return _fetcher;
  }
}
function getSubmittingFetcher(submission, existingFetcher) {
  var fetcher = {
    state: "submitting",
    formMethod: submission.formMethod,
    formAction: submission.formAction,
    formEncType: submission.formEncType,
    formData: submission.formData,
    json: submission.json,
    text: submission.text,
    data: existingFetcher ? existingFetcher.data : undefined
  };
  return fetcher;
}
function getDoneFetcher(data) {
  var fetcher = {
    state: "idle",
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined,
    data: data
  };
  return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
  try {
    var sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
    if (sessionPositions) {
      var _json2 = JSON.parse(sessionPositions);
      for (var _i2 = 0, _Object$entries2 = Object.entries(_json2 || {}); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          k = _Object$entries2$_i[0],
          v = _Object$entries2$_i[1];
        if (v && Array.isArray(v)) {
          transitions.set(k, new Set(v || []));
        }
      }
    }
  } catch (e) {
    // no-op, use default empty object
  }
}
function persistAppliedTransitions(_window, transitions) {
  if (transitions.size > 0) {
    var _json3 = {};
    var _iterator9 = _createForOfIteratorHelper(transitions),
      _step9;
    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var _step9$value = _slicedToArray(_step9.value, 2),
          k = _step9$value[0],
          v = _step9$value[1];
        _json3[k] = _toConsumableArray(v);
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
    try {
      _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(_json3));
    } catch (error) {
      warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
    }
  }
}
//#endregion

export { AbortedDeferredError, Action, IDLE_BLOCKER, IDLE_FETCHER, IDLE_NAVIGATION, UNSAFE_DEFERRED_SYMBOL, DeferredData as UNSAFE_DeferredData, ErrorResponseImpl as UNSAFE_ErrorResponseImpl, convertRouteMatchToUiMatch as UNSAFE_convertRouteMatchToUiMatch, convertRoutesToDataRoutes as UNSAFE_convertRoutesToDataRoutes, decodePath as UNSAFE_decodePath, getResolveToMatches as UNSAFE_getResolveToMatches, invariant as UNSAFE_invariant, warning as UNSAFE_warning, createBrowserHistory, createHashHistory, createMemoryHistory, createPath, createRouter, createStaticHandler, data, defer, generatePath, getStaticContextFromError, getToPathname, isDataWithResponseInit, isDeferredData, isRouteErrorResponse, joinPaths, json, matchPath, matchRoutes, normalizePathname, parsePath, redirect, redirectDocument, replace, resolvePath, resolveTo, stripBasename };